<template>
  <div class="section-content admin-content">
    <!-- Titulo de Pagina -->
    <div class="loading" v-if="patientLoading">

  <md-progress md-indeterminate></md-progress>
  <span>Cargando mapa de Pacientes para la comuna seleccionada...</span>
    </div>
    <div class="main-content">
       <!-- Graficos -->

      <!-- Resultados -->
      <div class="table-results display-flex justify-content-between align-items-start">
        <div class="title-results">
          <h3>Resultados de Pacientes
            <span class="bubble">{{ this.datatable.filters.pages.total }}</span>
          </h3>
          <p>Pacientes Totales:
            <strong>+2.300.000</strong>
          </p>
        </div>
        </div>

      <div class="alert alert-info" style="
    background: #39b7c0;
    color: white;
    padding: 10px;
    margin-bottom: 20px;
">Con el fin de proteger la privacidad de nuestros Pacientes no mostramos la identidad de ellos ni su ubicación exacta, la ubicación es modificada de manera al azar en un radio de 2km de la registrada en nuestros sistemas.</div>
      <!-- Google Maps -->
      <div class="google-map-results" >

        <gmap-map ref="google" :center="mapCenter" :zoom="mapZoom">
          <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
          {{infoContent}}
        </gmap-info-window>

          <gmap-marker
            :icon="'https://agendaenlinea.cl/consulta.png'"
            :position="officeLocation"
            v-if="officeLocation"
            :zIndex="100000000000"
          ></gmap-marker>

          <gmap-marker
            :key="rowIndex"
            v-for="(row, rowIndex) in companies"
            :icon="'https://agendaenlinea.cl/empresa.png'"
            :position="getPositionCoords(row)"
            :clickable="true" @click="toggleInfoWindow(row,rowIndex)"
            :zIndex="10000000000"
          ></gmap-marker>
        <!--  <gmap-marker
            :key="rowIndex"
            v-for="(row, rowIndex) in patients"
            :position="getPosition(row, rowIndex)"
          ></gmap-marker> -->
        </gmap-map>
      </div>

      <!-- Filtros de Tabla -->
      <div class="table-filters" style="    padding: 20px;
    background: #fafafa;" >
        <b> Calcule su alcance estimado, unicamente puede seleccionar comunas donde ud cuenta con una consulta / BOX : </b>
        <div style="padding: 20px;background: #dac50b6e;" v-if="this.datatable.filters.comunities.length == 0">Usted no cuenta con consultas / BOX </div>
       <!-- <md-input-container class="select-border filter-item">
           <label>País</label>
          <md-select placeholder="País" label="País" v-model="datatable.filters.options.country_filter">
            <md-option v-for="(row, rowIndex) in datatable.filters.countries" :key="rowIndex" :value="row.id">
              {{ row.name }}
            </md-option>
          </md-select>
        </md-input-container>

        <md-input-container class="select-border filter-item" v-if="datatable.filters.provinces.length">
                <label>Provincia</label>
          <md-select placeholder="Provincia" v-model="datatable.filters.options.province_filter">
            <md-option v-for="(row, rowIndex) in datatable.filters.provinces" :key="rowIndex" :value="row.id">
              {{ row.name }}
            </md-option>
          </md-select>
        </md-input-container>-->

        <md-input-container class="select-border filter-item" v-if="datatable.filters.comunities.length">
                 <label>Comuna</label>
          <md-select placeholder="Comuna" v-model="datatable.filters.options.comunity_filter">
            <md-option v-for="(row, rowIndex) in datatable.filters.comunities" :key="rowIndex" :value="row.id">
              {{ row.name }}
            </md-option>
          </md-select>
        </md-input-container>
        <!-- Filtro: Rango -->
        <!-- -->
      </div>

      <!-- Stats -->
      <div class="total-stats">
        <div class="row" >
          <div class="col-stats">
            <div class="stat-item">
              <h4>Alcance</h4>
              <h3 class="stat-price">
                <span class="sign"></span>{{ this.datatable.filters.pages.total ? this.datatable.filters.pages.total : "Seleccione una comuna" }}
                <div class="type"></div>
              </h3>
            </div>
          </div>
          <div class="col-stats">
            <div class="stat-item">
              <h4>Efectividad estimada</h4>
              <h3 class="stat-price">
                <span class="sign"></span>{{ this.datatable.filters.pages.total ? rounded(this.datatable.filters.pages.total*0.82) :  "Seleccione una comuna" }}
                <div class="type"></div>
              </h3>
            </div>
          </div>
        </div>
      </div>
     <md-button class="md-raised md-primary" @click="soon()">Promocionar</md-button>
    </div>
  <md-snackbar md-position="bottom center" ref="snackbar" md-duration="8000">
    <span>Hemos comenzado tu proceso de aprobación para publicar, Recibiras un correo una vez haya concluido el proceso.</span>
    <md-button class="md-accent" md-theme="light-blue" @click="$refs.snackbar.close()">OK</md-button>
  </md-snackbar>

<md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog1">
        <md-dialog-content>
        <b>Vista Previa</b>
        <md-button-toggle md-single>
  <md-button class="md-toggle"  @click="preview(1)">Correo Electronico</md-button>
  <md-button @click="preview(2)">WhatsApp</md-button>
  <md-button @click="preview(3)">Notificación Push</md-button>
</md-button-toggle>
        <div v-if="preview_item == 2" class="desktop_only" style="height: 450px;overflow:hidden;text-align:center">
<div class="marvel-device iphone-x" style="margin-top:15px;" >
    <div class="notch">
        <div class="camera"></div>
        <div class="speaker"></div>
    </div>
    <div class="top-bar"></div>
    <div class="sleep"></div>
    <div class="bottom-bar"></div>
    <div class="volume"></div>
    <div class="overflow">
        <div class="shadow shadow--tr"></div>
        <div class="shadow shadow--tl"></div>
        <div class="shadow shadow--br"></div>
        <div class="shadow shadow--bl"></div>
    </div>
    <div class="inner-shadow"></div>
    <div class="screen">

      <div class="screen-container">
        <div class="status-bar">
          <div class="time"></div>
          <div class="battery">
            <i class="zmdi zmdi-battery"></i>
          </div>
          <div class="network">
            <i class="zmdi zmdi-network"></i>
          </div>
          <div class="wifi">
            <i class="zmdi zmdi-wifi-alt-2"></i>
          </div>
          <div class="star">
            <i class="zmdi zmdi-star"></i>
          </div>
        </div>
        <div class="chat">
          <div class="chat-container">
            <div class="user-bar">
              <div class="back">
                <i class="zmdi zmdi-arrow-left"></i>
              </div>
              <div class="avatar">
                <img src="https://avatars2.githubusercontent.com/u/398893?s=128" alt="Avatar">
              </div>
              <div class="name">
                <span>Paciente</span>
                <span class="status">en linea</span>
              </div>
              <div class="actions more">
                <i class="zmdi zmdi-more-vert"></i>
              </div>
              <div class="actions attachment">
                <i class="zmdi zmdi-attachment-alt"></i>
              </div>
              <div class="actions">
                <i class="zmdi zmdi-phone"></i>
              </div>
            </div>
            <div class="conversation">
              <div class="conversation-container">
                <div class="message sent">
                  <span style="font-size: 18px; line-height: 21px;">Te invitamos a conocer a nuestro Prestador de Salud <b>{{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }}</b> especialista en <b><font v-for="(row, rowIndex) in the_doctor.specialities" :key="rowIndex">{{row.name}}{{ the_doctor.specialities.length > (rowIndex+1) ? ", " : ""}}</font></b> para agendar con el puedes presionar el siguiente botón:

<a href="javascript:;" class="btn btn-primary" style="
    color: blue;
    text-decoration: none;
    display:block;
    margin-top: 20px;
">Agendar con <b>
{{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }}</b> </a>


 </span>
                  <span class="metadata">
                      <span class="time"></span><span class="tick"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span>
                  </span>
                </div>
              </div>
              <form class="conversation-compose">
                <div class="emoji">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="smiley" x="3147" y="3209"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.153 11.603c.795 0 1.44-.88 1.44-1.962s-.645-1.96-1.44-1.96c-.795 0-1.44.88-1.44 1.96s.645 1.965 1.44 1.965zM5.95 12.965c-.027-.307-.132 5.218 6.062 5.55 6.066-.25 6.066-5.55 6.066-5.55-6.078 1.416-12.13 0-12.13 0zm11.362 1.108s-.67 1.96-5.05 1.96c-3.506 0-5.39-1.165-5.608-1.96 0 0 5.912 1.055 10.658 0zM11.804 1.01C5.61 1.01.978 6.034.978 12.23s4.826 10.76 11.02 10.76S23.02 18.424 23.02 12.23c0-6.197-5.02-11.22-11.216-11.22zM12 21.355c-5.273 0-9.38-3.886-9.38-9.16 0-5.272 3.94-9.547 9.214-9.547a9.548 9.548 0 0 1 9.548 9.548c0 5.272-4.11 9.16-9.382 9.16zm3.108-9.75c.795 0 1.44-.88 1.44-1.963s-.645-1.96-1.44-1.96c-.795 0-1.44.878-1.44 1.96s.645 1.963 1.44 1.963z" fill="#7d8489"/></svg>
                </div>
                <input class="input-msg" name="input" placeholder="Type a message" autocomplete="off" autofocus />
                <div class="photo">
                  <i class="zmdi zmdi-camera"></i>
                </div>
                <button class="send">
                    <div class="circle">
                      <i class="zmdi zmdi-mail-send"></i>
                    </div>
                  </button>
              </form>
</div>
    </div>
    </div>
    </div>
    </div>
</div>
        </div>
        <div v-if="preview_item == 1" class="desktop_only">
<iframe data-v-1dfe8a26="" :src="'https://tienda.agendaenlinea.cl/coco.php'+ paramsForIframe" style="
    width: 100%;
    height: 450px;
    border: 1px solid #39b7c0;
"></iframe>

        </div>
        <div v-if="preview_item == 3" style="height:450px;overflow:hidden" class="desktop_only">
<div class="sc-jDwBTQ egkRpC" style="margin-top:10px"><div class="sc-gPEVay dSmbrN"><div class="sc-iRbamj hQVZHz"><div class="sc-jlyJG jiSlDO"><span class="sc-csuQGl ezfjWK" style="font-weight: bold;">AMOL</span><span class="sc-Rmtcm deQnlS">now</span></div><div class="sc-gipzik eLaYeg"><div class="sc-hzDkRC jHeljQ"><div class="sc-jhAzac cypPtq"><div class="sc-fBuWsC jLtcjp">Prestador Destacado</div><div class="sc-fMiknA enniBG">Te invitamos a conocer a nuestro Prestador de Salud {{ the_doctor.name + " "+ (the_doctor.lastname ? the_doctor.lastname : "") }} especialista en <font v-for="(row, rowIndex) in the_doctor.specialities" :key="rowIndex">{{row.name}}{{ the_doctor.specialities.length > (rowIndex+1) ? ", " : ""}}</font> </div></div></div></div></div><div class="sc-fAjcbJ dgBCNv"><div class="sc-caSCKo bFdPyK">Agendar Hora</div></div></div></div>
        </div>
       <div class="movil_only">
         <div style="padding: 20px;background: #dac50b6e;" >No puedes visualizar las vistas previas en un dispositivo movil debido a que para generar una vista previa fidedigna se utiliza la misma resolucion y proporcion que un dispositivo movil. </div>
         </div>

        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary btn--cancel" @click.native="closeDialog('dialog1')">Cerrar</md-button>
          <md-button class="md-primary btn--save btn--blue" @click.native="soon2()">Publicar</md-button>
        </md-dialog-actions>
    </md-dialog>


  </div>

</template>
<script>

import {admin,public_api, doctor} from '../../config/api';
const swal = require("sweetalert2")
const _ = require('lodash')
import moment from 'moment'

export default {
  mounted(){
    // get Patients by role
   //this.getPatients()

    // get Countries
   this.getComunities()
    // get range Age limit
    // get count patients
    this.$http.get('/doctor/me', {
        headers: {
            Authorization : 'Bearer '+ this.$auth.getToken(),
        }
    }).then(response => {
        if(response.data.status == "OK"){
            let data = response.data.data;
            console.log(data)
            this.the_doctor = data;
        }
    });
  },
  data: () => ({
    communes: {
      "8261129": 2966,
      "8261144": 2678,
      "8261278": 9554,
      "8261279": 3445,
      "8261311": 11952,
      "8261384": 9887,
      "8261454": 3650,
      "6693568": 24663,
      "6693599": 9885,
      "8261423": 23666,
      "8261139": 2601,
      "8261226": 7603,
      "8261207": 16885,
      "8261383": 9885,
      "8261438": 24775,
      "8261165": 1896,
      "8261339": 4663,
      "8261369": 19887,
      "8261397": 9998,
      "8261398": 6889,
      "8261399": 7884,
      "8261400": 37162,
      "8261432": 9603,
      "8261421": 12886,
      "8261372": 9775,
      "8261405": 57995,
      "8261316": 3556,
      "8261407": 3556,
      "8261410": 29521,
      "8261428": 31445,
      "8261390": 7589,
      "8261156": 4552,
      "8261174": 17890,
      "8261194": 15992,
      "8261434": 25089,
      "8261178": 39554,
      "8261157": 16247,
      "8261413": 9896,
      "8261414": 39774,
      "8261436": 21550,
      "8261431": 9887,
      "8261416": 8061,
      "8261417": 10898,
      "8261418": 11445,
      "8261419": 17552,
      "8261377": 11669,
      "8261158": 3678,
      "8261395": 59887,
      "8261380": 29773,
      "8261346": 9603,
      "8261364": 890,
      "8261231": 3885,
      "8261457": 1204,
      "8261332": 1266,
      "8261285": 4856,
      "8261249": 22934,
      "8261239": 29716,
      "8261250": 3852
    },
    infoWindowPos: null,
          infoWinOpen: false,
          currentMidx: null,
          //optional: offset infowindow so it visually sits nicely on top of our marker
          infoOptions: {
            pixelOffset: {
              width: 0,
              height: -35
            }
          },
    companies: [],
    infoContent: "",
    officeLocation: false,
    mapZoom: 7,
    patientLoading: false,
    the_doctor : {
      code : '',
      name : '',
      lastname : '',
      lastname2 : '',
      email : '',
      phone : '',
      password : '',
      password_confirmation : '',
      notification_appointment : false,
      notification_mail : false,
      notification_sms : false,
      type: 'doctor',
      specialities: [],
      region: {label:'',value:''},
      city: {label:'',value:''},
      bon_particular: 1,
      bon_fonasa: 1,
      bon_isapre: 1
                },
    preview_item: 1,
    selected: [],
		selectAll: false,
    newComment: "",
    show_charts: false,
    total_reserves: 0,
    total_diaries: 0,
    countPatients: 0,
    data: {},
    graphs: {},
    show_map: false,
    mapCenter: {lat:-33.746124744005016, lng: -70.73784054505496},
    graph_models: [4, 0, 2, 3],
    graph_types: [
      "N° Pacientes vs Prevision",
      "N° Bonos por Prevision vs Tiempo",
      "N° Pacientes vs Comuna",
      "Ahorro total vs Prevision",
      "Gasto, Descuento, Ahorro vs Tiempo"
    ],
    graph_slots: [
      {}, {}, {}, {}
    ],
    totals: [],
    datatable: {
      filters: {
        search: {
          query: '',
          queryIsDirty: false,
          isCalculating: false,
          isQuery: false
        },
        visible: false,
        rows: [
          { value: 10, label: 'Mostrar 10' },
          { value: 20, label: 'Mostrar 20' },
          { value: 50, label: 'Mostrar 50' },
          { value: 100, label: 'Mostrar 100' },
          { value: 150, label: 'Mostrar 150' },
          { value: 200, label: 'Mostrar 200' },
          { value: 250, label: 'Mostrar 250' },
          { value: 300, label: 'Mostrar 300' },
        ],
        row_selected: 300,
        orderBy: [
          { value: '0', label: 'Ordenar Por' },
          { value: 'name', label: 'Nombre' },
          { value: 'rut', label: 'Rut' },
          { value: 'country', label: 'País' },
        ],
        countries: [],
        provinces: [],
        comunities: [],
        patient_types: [],
        previsions: [],
        boxes: [],
        ages: [],
        options: {
          country_filter: 0,
          province_filter: 0,
          comunity_filter: 0,
        },
        pages: {
          last_page: null,
          current_page: 1,
          first_page: 1,
          next_page_url: '',
          prev_page_url: ''
        }
      },
      total: {
        reserves: [],
        diaries: [],
        prices: [],
        discounts: [],
        final_prices: []
      }
    },
    patients: [],
    currentIndex: -1,
    patient_edit: {
      name: '',
      lastname: '',
      lastname2: '',
      phone: '',
      prevision_id: '',
      composensation_box_id: '',
      birth_date: '',
      date: '',
      currentDate: '',
    },
    previsions: [],
    disabledPrevisions: true,
    boxes: [],
    disabledPrevisions: true,
    patient_btn_edit: false,
  }),
  computed: {
    options() {
      return this.$store.getters.user.options
    },
    paramsForIframe(){
      let url = "?name="+ encodeURI(this.the_doctor.name + " "+ (this.the_doctor.lastname ? this.the_doctor.lastname : ""))
      this.the_doctor.specialities.forEach(function(v, i){
        url = url+"&specs[]="+encodeURI(v.name);
      });
       return url;
    },
    comunitySelected(){
      let filter = this.datatable.filters.comunities.filter((x) => {return x.id == this.datatable.filters.options.comunity_filter});

      console.log("filter",filter);
      return filter.length == 1 ? filter[0] : this.mapCenter;
    }
  },
  methods: {
    toggleInfoWindow(marker, idx) {
            this.infoWindowPos = this.getPositionCoords(marker);
            this.infoContent = 'Empresa - '+marker.workers+' Trabajadores';
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
          },
    getOfficeLocation(){
      let comunity = this.comunitySelected;
      console.log({lat: comunity.lat, lng: comunity.lng})
      return typeof comunity.lat == "undefined" ? false :  {lat: parseFloat(comunity.lat), lng: parseFloat(comunity.lng)};
    },
    rounded(num){
      return Math.floor(num)
    },
    preview(item){
      this.preview_item = item
    },
    soon2(){
      this.$refs.snackbar.open();
    },
    soon(){
      this.openDialog("dialog1")
      //this.$refs.snackbar.open();
    },

    // hasPerm
    // update map
    toggleMap(){

       setTimeout(() => {
          this.$refs.google.$mapCreated.then((map) => {
            var bounds = new google.maps.LatLngBounds();
            this.companies.forEach((patient) => {
              if(patient.has_location){
                bounds.extend(new google.maps.LatLng(  parseFloat(patient.lat), parseFloat(patient.lng)    ));
              } else if(patient.city){
                bounds.extend(new google.maps.LatLng(   parseFloat(patient.city.lat)-Math.random(), parseFloat(patient.city.lng)-(Math.random()/6)    ));
              }
            });
            map.fitBounds(bounds);
          });
        }, 250)
    },

    // Get patient_types
    getPatientTypes() {
      this.$http.get(admin.api.resources.patientTypes, {
              headers: {
                  Authorization : 'Bearer '+ this.$auth.getToken(),
              }
            })
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.name
            })
            data.unshift({id: 0, name: '-- Convenio --'})
            this.datatable.filters.patient_types = data
            this.disabledPatientTypes = false
          }
        })
    },
    // Get previsions by country
    getPrevisionsUser(country) {
      this.$http.get(public_api.api.previsions + `?country=${country}`)
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.display_name
            })
            this.previsions = data
            this.disabledPrevisions = false
          }
        })
    },
    // Get previsions by country
    getBoxesUser(country) {
      this.$http.get(public_api.api.boxes + `?country=${country}`)
        .then(response => {
          let data = response.data.data
          if (data.length) {
            data.map((item, index) => {
              item.value = item.id
              item.label = item.display_name
            })
            this.boxes = data
            this.disabledBoxes = false
          }
        })
    },
    submit(scope, type){
      var self = this;
      this.$validator.validateAll(scope)
        .then(function(result) {
          if (result) {
            self.patient_btn_edit = true;
            self.$http.put(admin.api.patients + '/update/' + self.patient_edit.id , self.patient_edit, {
                headers: {
                  Authorization: "Bearer " + self.$auth.getToken()
                }
              }).then(function(response){
                self.patient_btn_edit = false;
                let data_response = response.data.data;
                self.patients[self.currentIndex] = data_response
                self.closeDialog('editPatient');
                swal('', response.data.msg, 'success')
              }).catch(function(error){
                  self.patient_btn_edit = false;
                  if (error.response) {
                      let data = error.response.data;
                      if (error.response.status === 422) {
                          for (var index in data) {
                              var messages = "";
                              data[index].forEach(function(item) {
                                  messages += item + " ";
                              });
                              self._errors.errors.unshift({
                                  field: index,
                                  msg: messages,
                                  scope: scope
                              });
                          }
                      } else if (error.response.status === 401) {
                          self.errors.response.invalid = true;
                          self.errors.response.msg = "Datos incorrectos";
                      } else {
                          console.log(error);
                          alert("Error generic");
                      }
                  } else if (error.request) {
                      console.log(error.request);
                      alert("Error empty");
                  } else {
                      console.log("Error", error.message);
                      alert("Error");
                  }
              });
            }
        });
    },
    getDataGraphics(){
      this.$http.get(admin.api.graphics, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.graphs = data;
          this.graph_models =  [4, 0, 2, 3];
          this.graph_models.forEach(function(element, index) {
            this.updateGraph(index)
          }, this);
        })
    },
    formatNumber(value, coin) {
        if(coin == "CLP"){
          return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : 0
        }
        return value
    },

    openDialog(ref, row, rowIndex) {
      console.log(row);
      if(ref == "editPatient"){
          if(!this.hasPerm('patients/update')) {
            ref = "viewPatient";
            //return;
          }
        }
        console.log("323")
      if(row){
        if(row.birth_date){
          let arr_date = row.birth_date.split('/');
          let birth_date = arr_date[2] + '-' + Number(arr_date[1]) + '-' + arr_date[0]
          row.birth_date = moment(birth_date, "YYYY-MM-DD").format();
          row.current_date = moment(birth_date, "YYYY-MM-DD").format();
        }else{
          row.birth_date = moment().format();
          row.current_date = moment().format();
        }
        this.patient_edit = row;
        this.currentIndex = rowIndex;
        this.getPrevisionsUser(row.country.countryCode)
        this.getBoxesUser(row.country.countryCode)
      }
      setTimeout(() => {
          this.$refs[ref].open();
      },250)
    },
    mailificator(row){
      let name = row.name +" " +(row.lastname ? row.lastname : '')+" " +(row.lastname2 ? row.lastname2 : '');
      let splited = name.split(" ");
      let email = splited.join(".")+"@gmail.com";
      return email.toLowerCase();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
    onOpen() {
      // console.log('Opened');
    },
    onClose(type) {
      // console.log('Closed', type);
    },
 /*   generateRandomPoints(center, radius, count) {
  var points = [];
  for (var i=0; i<count; i++) {
    points.push(generateRandomPoint(center, radius));
  }
  return points;
},*/


/**
* Generates number of random geolocation points given a center and a radius.
* Reference URL: http://goo.gl/KWcPE.
* @param  {Object} center A JS object with lat and lng attributes.
* @param  {number} radius Radius in meters.
* @return {Object} The generated random points as JS object with lat and lng attributes.
*/
generateRandomPoint(center, radius) {
  var x0 = center.lng;
  var y0 = center.lat;
  // Convert Radius from meters to degrees.
  var rd = radius/111300;

  var u = Math.random();
  var v = Math.random();

  var w = rd * Math.sqrt(u);
  var t = 2 * Math.PI * v;
  var x = w * Math.cos(t);
  var y = w * Math.sin(t);

  var xp = x/Math.cos(y0);

  // Resulting point.
  return {'lat': y+y0, 'lng': xp+x0};
},
    getPosition(length, row, index){
      if(index = (length - 1)){
        this.toggleMap()
        this.patientLoadingOff();
        this.mapZoom = 17
        this.mapCenter = this.officeLocation
      }
      if(row.has_location){
        let coords = {lat: parseFloat(row.lat), lng: parseFloat(row.lng)};
        return coords;
      } else
      if(row.city){
        let vary = 250
        if(this.datatable.filters.options.comunity_filter > 0 ){
          //console.log("vary all", this.datatable.filters.options.comunity_filter)

          //vary = 2000;
          vary= Math.floor(Math.random() * (2020 - 10 + 1)) + 10;
        }
        console.log("variando en", vary)
        //vary = 25
        //console.log("aplicando algoritmo", Object.assign({}, this.officeLocation))
        let coords = this.generateRandomPoint({lat: parseFloat(this.officeLocation.lat), lng: parseFloat(this.officeLocation.lng)  }, vary)
       //console.log("sin location usando lat y long de a ciudad", coords)
       return coords;
      }
    },
    getPositionCoords(item) {
      let coords = {lat: parseFloat(item.lat), lng: parseFloat(item.lng)  }
       //console.log("sin location usando lat y long de a ciudad", coords)
       return coords;
    },
    // Method to search
    expensiveOperation: _.debounce(function () {
      this.getPatients()
    }, 500),
    // get Patietns
    preprocessFilters(filters){
      let final_filters = {};
      for (var key in filters) {
        if (filters.hasOwnProperty(key)) {
          final_filters[key] = this.preprocessFilter(filters[key]);
        }
      }
      return final_filters;
    },
    preprocessFilter(filter){

      if(filter && typeof filter == "object" && (filter.value || filter.id) ){
        return filter.id ? filter.id : filter.value;
      }
      return filter;
    },
    patientLoadingOff(){
      setTimeout(function(){
this.patientLoading = false;
      }.bind(this), 1000);

    },
    addMarkers(points){
      //console.log(points)
      let map = this.$refs.google.$mapObject;
      points.forEach((point,i) => {
        console.log("mapa", this.getPosition(points.length, point, i))
       let marker = new google.maps.Marker({
          position: this.getPosition(points.length, point, i),
          map: map
      });
      })
    },
    getPatients(){
      this.patientLoading = true;
      let page = '';
      let filter = this.datatable.filters.options
      filter.row_selected = this.datatable.filters.row_selected
      // filter.pages = this.datatable.filters.pages
      let url = admin.api.patients
      //filter = this.preprocessFilters(filter);
      this.$http.post(url, filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;

              let copy = Object.assign({}, data.data[0]);
              data.data = [];
              let comunity_id = this.comunitySelected.id
              let community_patients = this.communes[comunity_id] ? this.communes[comunity_id] : 0;
              console.log("pacientes", community_patients)
              for (var index = 0; index < (community_patients > 5000 ? 5000 : community_patients); index++) {
                data.data.push(copy);
              }
              if(community_patients == 0){
                this.patientLoadingOff();
              }

          //this.patients = data.data
          console.log("#")
          this.addMarkers(data.data);

          //this.toggleMap();
          // set pages
          this.datatable.filters.pages = {
            last_page: data.last_page,
            current_page: data.current_page,
            first_page: 1,
            next_page_url: data.next_page_url,
            prev_page_url: data.prev_page_url,
            total: community_patients
          }
          // set makers
          // set total footer
          //this.setTotalFooter(data)
        })

        this.$http.post(admin.api.companies, filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.companies = data.data;
          console.log("companies", this.companies)
          // set makers
          // set total footer
          //this.setTotalFooter(data)
        })

    },
    // set Total footer
    setTotalFooter(data){
      let total = {
        countries : []
      }
      let total_patients = data.data.length
      var self = this
      var pos = 0
      if(data.data.length){
        data.data.map( (patient,index) => {
          if(index == 0){
            let obj = {
              country: patient.country,
              currency: patient.country.currency,
              total: {reserve: 0, diary: 0, price: 0, discount: 0, final_price: 0},
              pos: pos
            }
            if(patient.reserves_count.length > 0){
                obj.total.reserve += patient.reserves_count[0].total_reserves
            }
            if(patient.diaries_count.length > 0){
              obj.total.diary += patient.diaries_count[0].total_diaries
            }
            if(patient.bonuses_total.length > 0){
              obj.total.price += patient.bonuses_total[0].total_price
              obj.total.discount += patient.bonuses_total[0].total_discount
              obj.total.final_price += patient.bonuses_total[0].total_final_price
            }
            total.countries.push(obj)
            pos++;
          }else{
            // filter index
            let country_search = total.countries.find(country => country.currency.id == patient.country.currency.id)
            if(typeof(country_search) != 'undefined'){
              let index_search = country_search.pos;
              if(patient.reserves_count.length > 0){
                total.countries[index_search].total.reserve += patient.reserves_count[0].total_reserves
              }
              if(patient.diaries_count.length > 0){
                total.countries[index_search].total.diary += patient.diaries_count[0].total_diaries
              }
              if(patient.bonuses_total.length > 0){
                total.countries[index_search].total.price += patient.bonuses_total[0].total_price
                total.countries[index_search].total.discount += patient.bonuses_total[0].total_discount
                total.countries[index_search].total.final_price += patient.bonuses_total[0].total_final_price
              }
            }else{
              let obj = {
                country: patient.country,
                currency: patient.country.currency,
                total: {reserve: 0, diary: 0, price: 0, discount: 0, final_price: 0},
                pos: pos
              }
              if(patient.reserves_count.length > 0){
                  obj.total.reserve += patient.reserves_count[0].total_reserves
              }
              if(patient.diaries_count.length > 0){
                obj.total.diary += patient.diaries_count[0].total_diaries
              }
              if(patient.bonuses_total.length > 0){
                obj.total.price += patient.bonuses_total[0].total_price
                obj.total.discount += patient.bonuses_total[0].total_discount
                obj.total.final_price += patient.bonuses_total[0].total_final_price
              }
              total.countries.push(obj)
              pos++;
            }
          }
          // set totals
          if(total_patients-1 == index){
            self.datatable.total = total
          }
        })
      }else{
        self.datatable.total = { countries: [] }
      }
    },
    // get count Patients
    getCountPatients(){
      this.$http.get(admin.api.patients_count, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.countPatients = data.total_patients
        })
    },
    // get Countries
    getCountries(){
      this.$http.get(admin.api.countries, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          let r_data = [{"id":3895114,"name":"Chile"}];
          r_data.unshift({id: 0, name: '-- País --'})
          this.datatable.filters.countries = r_data;
        })
    },
    // get Range age
    getRangeAge(){
      let limit = 105;
      this.datatable.filters.ages.push({label: 'Edad', value: null});
      for(let i = 0; i <= limit; i = i +5){

          this.datatable.filters.ages.push({label: i, value: i});
      }
    },
    getRegions(){
      this.$http.get(admin.api.regions + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Provincia --'})
          this.datatable.filters.provinces = data;
        })
    },
    getComunities(){
       this.$http.get(doctor.api.offices,{
          headers: {
              Authorization : 'Bearer '+ this.$auth.getToken(),
          }
          }).then(response => {
              let data = response.data.data;
              console.log(data);
              let comunity_offices = [];
              data.forEach(function(v,i){
                comunity_offices.push({id: v.comunity_id, name: v.comunity, has_location: v.has_location, lat: v.lat, lng:v.lng})
              })
              this.datatable.filters.comunities = comunity_offices;
              // storage comunities
              //this.offices = data;
              //this.fetchData = true;
          }).catch(error => {
              if(!error.response)
              {
                  if(error.request.status == 0)
                  {
                      this.$router.push({'name':'logout'});
                  }
              }
          });
      /*this.$http.get(admin.api.comunities + '/' + this.datatable.filters.options.province_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Comuna --'})
          this.datatable.filters.comunities = data;
        })*/
    },
    getPrevisions(){
      this.$http.get(admin.api.previsions + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Prevision --'})
          this.datatable.filters.previsions = data;
        })
    },
    getBoxes(){
      this.$http.get(admin.api.boxes + '/' + this.datatable.filters.options.country_filter, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          data.unshift({id: 0, name: '-- Caja de Compensación --'})
          this.datatable.filters.boxes = data;
        })
    },
    getTotals(){
      this.$http.get('https://api.agendaenlinea.cl/api/stats').then(response => {
          let data = response.data;
          this.total_reserves = data.reserves.always;
          this.total_diaries = data.diaries.always;
        })

      this.$http.get(admin.api.patient_totals, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken()
          }
        }).then(response => {
          let data = response.data.data;
          this.totals = data;
        })
    },
    // Delete user
    remove(row, rowIndex){
      swal("Eliminar Paciente", "¿Esta seguro de eliminar el Paciente?", 'warning')
        .then( () => {
          this.$http.delete(admin.api.patient_remove + '/' + row.id, {
              headers: {
                  Authorization : 'Bearer '+ this.$auth.getToken(),
              }
            }).then(response => {
              let data = response.data.data;
              swal('', response.data.msg, 'success')
                .then( () => {
                  this.patients.splice(rowIndex, 1);
                  this.getPatients()
                }, (dismiss) => {
                  this.patients.splice(rowIndex, 1);
                  this.getPatients()
                });
          }).catch(error => {
            console.log(error);
          });
        }, (dismiss) => {
            //console.log(dismiss);
        })
    }
  },
  watch: {
    'datatable.filters.search.query': function () {
      this.expensiveOperation()
    },
    'datatable.filters.row_selected': function() {
      this.getPatients()
    },
    'datatable.filters.options.order_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.country_filter': function(){
      this.datatable.filters.options.province_filter = 0
      this.datatable.filters.options.comunity_filter = 0
      this.datatable.filters.options.prevision_filter = 0
      this.datatable.filters.options.box_filter = 0
      if(this.datatable.filters.options.country_filter > 0){
        // get regions
        this.getRegions()
      }else{
        this.datatable.filters.regions = []
        this.datatable.filters.previsions = []
        this.datatable.filters.boxes = []
      }
      this.datatable.filters.provinces = []
      this.datatable.filters.comunities = []
      this.getPatients()
    },
    'datatable.filters.options.province_filter': function(){
      console.log("change", this.datatable.filters.options.province_filter)
      this.datatable.filters.options.comunity_filter = 0
      if(this.datatable.filters.options.province_filter > 0){
        // get comunities
        this.getComunities()
      }else{
        this.datatable.filters.comunities = []
      }
      this.getPatients()
    },
    'datatable.filters.options.comunity_filter': function(){
      this.officeLocation = this.getOfficeLocation()
      this.getPatients()
    },
    'datatable.filters.options.prevision_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.box_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.gender_filter': function(){
      this.getPatients()
    },
    'datatable.filters.options.age_filter_lower': function(){
      this.getPatients()
    },
    'datatable.filters.options.age_filter_upper': function(){
      this.getPatients()
    },
    'datatable.filters.options.patient_type_filter': function(){
      this.getPatients()
    }
  }
}
</script>
<style lang="stylus">
@import '../../assets/styles/variables/color.styl'
@import '../../assets/styles/admin/style.styl'
.money_display, .money_display .md-table-cell-container
  margin-top 5px
  word-break keep-all
  white-space nowrap
  font-size 10px
.show_small
    display none
.table.table-patient-list
  .md-table-cell-container
    .bubble-gray
      margin-top 0 !important
      display inline-block !important
    .bubble-gray + .bubble-gray
      margin-top 6px !important
.table.table-patient-list
  .total-countries-list
    display flex
    flex-flow column nowrap
    align-items center
    justify-content center
  .total-reserves
    padding-top 5px
@media (max-width: 920px)
	.table.table-patient-list.table-responsive
		table
			thead th:nth-child(7)
			tbody td:nth-child(7)
				display none
			abbr
				display inline-block !important
			span.country
				display none
@media (max-width: 800px)
  .md-table-cell[data-name="Especialidades"] div
    text-align center !important

	.table.table-patient-list.table-responsive
		table
			thead th:nth-child(8)
			tbody td:nth-child(8)
				display none

@media (max-width: 768px)
	/* Listado de Pacientes =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
	.app-main .content-container
    .table.table-mobile-format
      thead
        th
          display none !important
      tbody
        td
          display none !important
        tr.md-table-row:nth-child(odd) .md-table-cell
          background-color #F5F5F5

      thead th.data-mobile
      tbody td.data-mobile
        display table-cell !important


@media (max-width: 520px)
	.app-main .content-container .space-between
		flex-flow row wrap
		.search-wrap
			margin-bottom 10px
		.table-options .filter-options .md-button
			margin-left 0 !important
	.app-main .content-container
		.table-options .filter-options .md-button
			margin-left 0 !important
		.table-results
			flex-flow column nowrap
			.google-maps-action
				padding-left 0
				padding-top 15px
				top 0
		.table.table-patient-list
			table
				td:nth-child(9)
					max-width 280px
					word-wrap break-word
	.table.table-patient-list.table-responsive
		table
			td
			th
				padding-left 85px
</style>
<style>
.marvel-device{display:inline-block;position:relative;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}.marvel-device .screen{width:100%;position:relative;height:100%;z-index:3;background:white;overflow:hidden;display:block;border-radius:1px;-webkit-box-shadow:0 0 0 3px #111;box-shadow:0 0 0 3px #111}.marvel-device .top-bar,.marvel-device .bottom-bar{height:3px;background:black;width:100%;display:block}.marvel-device .middle-bar{width:3px;height:4px;top:0px;left:90px;background:black;position:absolute}.marvel-device.iphone8{width:375px;height:667px;padding:105px 24px;background:#d9dbdc;border-radius:56px;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.2);box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.2)}.marvel-device.iphone8:before{width:calc(100% - 12px);height:calc(100% - 12px);position:absolute;top:6px;content:'';left:6px;border-radius:50px;background:#f8f8f8;z-index:1}.marvel-device.iphone8:after{width:calc(100% - 16px);height:calc(100% - 16px);position:absolute;top:8px;content:'';left:8px;border-radius:48px;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #fff;box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #fff;z-index:2}.marvel-device.iphone8 .home{border-radius:100%;width:68px;height:68px;position:absolute;left:50%;margin-left:-34px;bottom:22px;z-index:3;background:#303233;background:linear-gradient(135deg, #303233 0%, #b5b7b9 50%, #f0f2f2 69%, #303233 100%)}.marvel-device.iphone8 .home:before{background:#f8f8f8;position:absolute;content:'';border-radius:100%;width:calc(100% - 8px);height:calc(100% - 8px);top:4px;left:4px}.marvel-device.iphone8 .top-bar{height:14px;background:#bfbfc0;position:absolute;top:68px;left:0}.marvel-device.iphone8 .bottom-bar{height:14px;background:#bfbfc0;position:absolute;bottom:68px;left:0}.marvel-device.iphone8 .sleep{position:absolute;top:190px;right:-4px;width:4px;height:66px;border-radius:0px 2px 2px 0px;background:#d9dbdc}.marvel-device.iphone8 .volume{position:absolute;left:-4px;top:188px;z-index:0;height:66px;width:4px;border-radius:2px 0px 0px 2px;background:#d9dbdc}.marvel-device.iphone8 .volume:before{position:absolute;left:2px;top:-78px;height:40px;width:2px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone8 .volume:after{position:absolute;left:0px;top:82px;height:66px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone8 .camera{background:#3c3d3d;width:12px;height:12px;position:absolute;top:24px;left:50%;margin-left:-6px;border-radius:100%;z-index:3}.marvel-device.iphone8 .sensor{background:#3c3d3d;width:16px;height:16px;position:absolute;top:49px;left:134px;z-index:3;border-radius:100%}.marvel-device.iphone8 .speaker{background:#292728;width:70px;height:6px;position:absolute;top:54px;left:50%;margin-left:-35px;border-radius:6px;z-index:3}.marvel-device.iphone8.gold{background:#f9e7d3}.marvel-device.iphone8.gold .top-bar,.marvel-device.iphone8.gold .bottom-bar{background:white}.marvel-device.iphone8.gold .sleep,.marvel-device.iphone8.gold .volume{background:#f9e7d3}.marvel-device.iphone8.gold .home{background:#cebba9;background:linear-gradient(135deg, #cebba9 0%, #f9e7d3 50%, #cebba9 100%)}.marvel-device.iphone8.black{background:#464646;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.7);box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.7)}.marvel-device.iphone8.black:before{background:#080808}.marvel-device.iphone8.black:after{-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #212121;box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #212121}.marvel-device.iphone8.black .top-bar,.marvel-device.iphone8.black .bottom-bar{background:#212121}.marvel-device.iphone8.black .volume,.marvel-device.iphone8.black .sleep{background:#464646}.marvel-device.iphone8.black .camera{background:#080808}.marvel-device.iphone8.black .home{background:#080808;background:linear-gradient(135deg, #080808 0%, #464646 50%, #080808 100%)}.marvel-device.iphone8.black .home:before{background:#080808}.marvel-device.iphone8.landscape{padding:24px 105px;height:375px;width:667px}.marvel-device.iphone8.landscape .sleep{top:100%;border-radius:0px 0px 2px 2px;right:190px;height:4px;width:66px}.marvel-device.iphone8.landscape .volume{width:66px;height:4px;top:-4px;left:calc(100% - 188px - 66px);border-radius:2px 2px 0px 0px}.marvel-device.iphone8.landscape .volume:before{width:40px;height:2px;top:2px;right:-78px;left:auto;border-radius:2px 2px 0px 0px}.marvel-device.iphone8.landscape .volume:after{left:-82px;width:66px;height:4px;top:0;border-radius:2px 2px 0px 0px}.marvel-device.iphone8.landscape .top-bar{width:14px;height:100%;left:calc(100% - 68px -  14px);top:0}.marvel-device.iphone8.landscape .bottom-bar{width:14px;height:100%;left:68px;top:0}.marvel-device.iphone8.landscape .home{top:50%;margin-top:-34px;margin-left:0;left:22px}.marvel-device.iphone8.landscape .sensor{top:134px;left:calc(100% - 49px - 16px)}.marvel-device.iphone8.landscape .speaker{height:70px;width:6px;left:calc(100% - 54px - 6px);top:50%;margin-left:0px;margin-top:-35px}.marvel-device.iphone8.landscape .camera{left:calc(100% - 32px);top:50%;margin-left:0px;margin-top:-5px}.marvel-device.iphone8plus{width:414px;height:736px;padding:112px 26px;background:#d9dbdc;border-radius:56px;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.2);box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.2)}.marvel-device.iphone8plus:before{width:calc(100% - 12px);height:calc(100% - 12px);position:absolute;top:6px;content:'';left:6px;border-radius:50px;background:#f8f8f8;z-index:1}.marvel-device.iphone8plus:after{width:calc(100% - 16px);height:calc(100% - 16px);position:absolute;top:8px;content:'';left:8px;border-radius:48px;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #fff;box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #fff;z-index:2}.marvel-device.iphone8plus .home{border-radius:100%;width:68px;height:68px;position:absolute;left:50%;margin-left:-34px;bottom:24px;z-index:3;background:#303233;background:linear-gradient(135deg, #303233 0%, #b5b7b9 50%, #f0f2f2 69%, #303233 100%)}.marvel-device.iphone8plus .home:before{background:#f8f8f8;position:absolute;content:'';border-radius:100%;width:calc(100% - 8px);height:calc(100% - 8px);top:4px;left:4px}.marvel-device.iphone8plus .top-bar{height:14px;background:#bfbfc0;position:absolute;top:68px;left:0}.marvel-device.iphone8plus .bottom-bar{height:14px;background:#bfbfc0;position:absolute;bottom:68px;left:0}.marvel-device.iphone8plus .sleep{position:absolute;top:190px;right:-4px;width:4px;height:66px;border-radius:0px 2px 2px 0px;background:#d9dbdc}.marvel-device.iphone8plus .volume{position:absolute;left:-4px;top:188px;z-index:0;height:66px;width:4px;border-radius:2px 0px 0px 2px;background:#d9dbdc}.marvel-device.iphone8plus .volume:before{position:absolute;left:2px;top:-78px;height:40px;width:2px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone8plus .volume:after{position:absolute;left:0px;top:82px;height:66px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone8plus .camera{background:#3c3d3d;width:12px;height:12px;position:absolute;top:29px;left:50%;margin-left:-6px;border-radius:100%;z-index:3}.marvel-device.iphone8plus .sensor{background:#3c3d3d;width:16px;height:16px;position:absolute;top:54px;left:154px;z-index:3;border-radius:100%}.marvel-device.iphone8plus .speaker{background:#292728;width:70px;height:6px;position:absolute;top:59px;left:50%;margin-left:-35px;border-radius:6px;z-index:3}.marvel-device.iphone8plus.gold{background:#f9e7d3}.marvel-device.iphone8plus.gold .top-bar,.marvel-device.iphone8plus.gold .bottom-bar{background:white}.marvel-device.iphone8plus.gold .sleep,.marvel-device.iphone8plus.gold .volume{background:#f9e7d3}.marvel-device.iphone8plus.gold .home{background:#cebba9;background:linear-gradient(135deg, #cebba9 0%, #f9e7d3 50%, #cebba9 100%)}.marvel-device.iphone8plus.black{background:#464646;-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.7);box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.7)}.marvel-device.iphone8plus.black:before{background:#080808}.marvel-device.iphone8plus.black:after{-webkit-box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #212121;box-shadow:inset 0 0 3px 0 rgba(0,0,0,0.1),inset 0 0 6px 3px #212121}.marvel-device.iphone8plus.black .top-bar,.marvel-device.iphone8plus.black .bottom-bar{background:#212121}.marvel-device.iphone8plus.black .volume,.marvel-device.iphone8plus.black .sleep{background:#464646}.marvel-device.iphone8plus.black .camera{background:#080808}.marvel-device.iphone8plus.black .home{background:#080808;background:linear-gradient(135deg, #080808 0%, #464646 50%, #080808 100%)}.marvel-device.iphone8plus.black .home:before{background:#080808}.marvel-device.iphone8plus.landscape{padding:26px 112px;height:414px;width:736px}.marvel-device.iphone8plus.landscape .sleep{top:100%;border-radius:0px 0px 2px 2px;right:190px;height:4px;width:66px}.marvel-device.iphone8plus.landscape .volume{width:66px;height:4px;top:-4px;left:calc(100% - 188px - 66px);border-radius:2px 2px 0px 0px}.marvel-device.iphone8plus.landscape .volume:before{width:40px;height:2px;top:2px;right:-78px;left:auto;border-radius:2px 2px 0px 0px}.marvel-device.iphone8plus.landscape .volume:after{left:-82px;width:66px;height:4px;top:0;border-radius:2px 2px 0px 0px}.marvel-device.iphone8plus.landscape .top-bar{width:14px;height:100%;left:calc(100% - 68px -  14px);top:0}.marvel-device.iphone8plus.landscape .bottom-bar{width:14px;height:100%;left:68px;top:0}.marvel-device.iphone8plus.landscape .home{top:50%;margin-top:-34px;margin-left:0;left:24px}.marvel-device.iphone8plus.landscape .sensor{top:154px;left:calc(100% - 54px - 16px)}.marvel-device.iphone8plus.landscape .speaker{height:70px;width:6px;left:calc(100% - 59px - 6px);top:50%;margin-left:0px;margin-top:-35px}.marvel-device.iphone8plus.landscape .camera{left:calc(100% - 29px);top:50%;margin-left:0px;margin-top:-5px}.marvel-device.iphone5s,.marvel-device.iphone5c{padding:105px 22px;background:#2c2b2c;width:320px;height:568px;border-radius:50px}.marvel-device.iphone5s:before,.marvel-device.iphone5c:before{width:calc(100% - 8px);height:calc(100% - 8px);position:absolute;top:4px;content:'';left:4px;border-radius:46px;background:#1e1e1e;z-index:1}.marvel-device.iphone5s .sleep,.marvel-device.iphone5c .sleep{position:absolute;top:-4px;right:60px;width:60px;height:4px;border-radius:2px 2px 0px 0px;background:#282727}.marvel-device.iphone5s .volume,.marvel-device.iphone5c .volume{position:absolute;left:-4px;top:180px;z-index:0;height:27px;width:4px;border-radius:2px 0px 0px 2px;background:#282727}.marvel-device.iphone5s .volume:before,.marvel-device.iphone5c .volume:before{position:absolute;left:0px;top:-75px;height:35px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone5s .volume:after,.marvel-device.iphone5c .volume:after{position:absolute;left:0px;bottom:-64px;height:27px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone5s .camera,.marvel-device.iphone5c .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:32px;left:50%;margin-left:-5px;border-radius:5px;z-index:3}.marvel-device.iphone5s .sensor,.marvel-device.iphone5c .sensor{background:#3c3d3d;width:10px;height:10px;position:absolute;top:60px;left:160px;z-index:3;margin-left:-32px;border-radius:5px}.marvel-device.iphone5s .speaker,.marvel-device.iphone5c .speaker{background:#292728;width:64px;height:10px;position:absolute;top:60px;left:50%;margin-left:-32px;border-radius:5px;z-index:3}.marvel-device.iphone5s.landscape,.marvel-device.iphone5c.landscape{padding:22px 105px;height:320px;width:568px}.marvel-device.iphone5s.landscape .sleep,.marvel-device.iphone5c.landscape .sleep{right:-4px;top:calc(100% - 120px);height:60px;width:4px;border-radius:0px 2px 2px 0px}.marvel-device.iphone5s.landscape .volume,.marvel-device.iphone5c.landscape .volume{width:27px;height:4px;top:-4px;left:calc(100% - 180px);border-radius:2px 2px 0px 0px}.marvel-device.iphone5s.landscape .volume:before,.marvel-device.iphone5c.landscape .volume:before{width:35px;height:4px;top:0px;right:-75px;left:auto;border-radius:2px 2px 0px 0px}.marvel-device.iphone5s.landscape .volume:after,.marvel-device.iphone5c.landscape .volume:after{bottom:0px;left:-64px;z-index:999;height:4px;width:27px;border-radius:2px 2px 0px 0px}.marvel-device.iphone5s.landscape .sensor,.marvel-device.iphone5c.landscape .sensor{top:160px;left:calc(100% - 60px);margin-left:0px;margin-top:-32px}.marvel-device.iphone5s.landscape .speaker,.marvel-device.iphone5c.landscape .speaker{height:64px;width:10px;left:calc(100% - 60px);top:50%;margin-left:0px;margin-top:-32px}.marvel-device.iphone5s.landscape .camera,.marvel-device.iphone5c.landscape .camera{left:calc(100% - 32px);top:50%;margin-left:0px;margin-top:-5px}.marvel-device.iphone5s .home{border-radius:36px;width:68px;-webkit-box-shadow:inset 0 0 0 4px #2c2b2c;box-shadow:inset 0 0 0 4px #2c2b2c;height:68px;position:absolute;left:50%;margin-left:-34px;bottom:19px;z-index:3}.marvel-device.iphone5s .top-bar{top:70px;position:absolute;left:0}.marvel-device.iphone5s .bottom-bar{bottom:70px;position:absolute;left:0}.marvel-device.iphone5s.landscape .home{left:19px;bottom:50%;margin-bottom:-34px;margin-left:0px}.marvel-device.iphone5s.landscape .top-bar{left:70px;top:0px;width:3px;height:100%}.marvel-device.iphone5s.landscape .bottom-bar{right:70px;left:auto;bottom:0px;width:3px;height:100%}.marvel-device.iphone5s.silver{background:#bcbcbc}.marvel-device.iphone5s.silver:before{background:#fcfcfc}.marvel-device.iphone5s.silver .volume,.marvel-device.iphone5s.silver .sleep{background:#d6d6d6}.marvel-device.iphone5s.silver .top-bar,.marvel-device.iphone5s.silver .bottom-bar{background:#eaebec}.marvel-device.iphone5s.silver .home{-webkit-box-shadow:inset 0 0 0 4px #bcbcbc;box-shadow:inset 0 0 0 4px #bcbcbc}.marvel-device.iphone5s.gold{background:#f9e7d3}.marvel-device.iphone5s.gold:before{background:#fcfcfc}.marvel-device.iphone5s.gold .volume,.marvel-device.iphone5s.gold .sleep{background:#f9e7d3}.marvel-device.iphone5s.gold .top-bar,.marvel-device.iphone5s.gold .bottom-bar{background:white}.marvel-device.iphone5s.gold .home{-webkit-box-shadow:inset 0 0 0 4px #f9e7d3;box-shadow:inset 0 0 0 4px #f9e7d3}.marvel-device.iphone5c{background:white;-webkit-box-shadow:0 1px 2px 0 rgba(0,0,0,0.2);box-shadow:0 1px 2px 0 rgba(0,0,0,0.2)}.marvel-device.iphone5c .top-bar,.marvel-device.iphone5c .bottom-bar{display:none}.marvel-device.iphone5c .home{background:#242324;border-radius:36px;width:68px;height:68px;z-index:3;position:absolute;left:50%;margin-left:-34px;bottom:19px}.marvel-device.iphone5c .home:after{width:20px;height:20px;border:1px solid rgba(255,255,255,0.1);border-radius:4px;position:absolute;display:block;content:'';top:50%;left:50%;margin-top:-11px;margin-left:-11px}.marvel-device.iphone5c.landscape .home{left:19px;bottom:50%;margin-bottom:-34px;margin-left:0px}.marvel-device.iphone5c .volume,.marvel-device.iphone5c .sleep{background:#dddddd}.marvel-device.iphone5c.red{background:#f96b6c}.marvel-device.iphone5c.red .volume,.marvel-device.iphone5c.red .sleep{background:#ed5758}.marvel-device.iphone5c.yellow{background:#f2dc60}.marvel-device.iphone5c.yellow .volume,.marvel-device.iphone5c.yellow .sleep{background:#e5ce4c}.marvel-device.iphone5c.green{background:#97e563}.marvel-device.iphone5c.green .volume,.marvel-device.iphone5c.green .sleep{background:#85d94d}.marvel-device.iphone5c.blue{background:#33a2db}.marvel-device.iphone5c.blue .volume,.marvel-device.iphone5c.blue .sleep{background:#2694cd}.marvel-device.iphone4s{padding:129px 27px;width:320px;height:480px;background:#686868;border-radius:54px}.marvel-device.iphone4s:before{content:'';width:calc(100% - 8px);height:calc(100% - 8px);position:absolute;top:4px;left:4px;z-index:1;border-radius:50px;background:#1e1e1e}.marvel-device.iphone4s .top-bar{top:60px;position:absolute;left:0}.marvel-device.iphone4s .bottom-bar{bottom:90px;position:absolute;left:0}.marvel-device.iphone4s .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:72px;left:134px;z-index:3;margin-left:-5px;border-radius:100%}.marvel-device.iphone4s .speaker{background:#292728;width:64px;height:10px;position:absolute;top:72px;left:50%;z-index:3;margin-left:-32px;border-radius:5px}.marvel-device.iphone4s .sensor{background:#292728;width:40px;height:10px;position:absolute;top:36px;left:50%;z-index:3;margin-left:-20px;border-radius:5px}.marvel-device.iphone4s .home{background:#242324;border-radius:100%;width:72px;height:72px;z-index:3;position:absolute;left:50%;margin-left:-36px;bottom:30px}.marvel-device.iphone4s .home:after{width:20px;height:20px;border:1px solid rgba(255,255,255,0.1);border-radius:4px;position:absolute;display:block;content:'';top:50%;left:50%;margin-top:-11px;margin-left:-11px}.marvel-device.iphone4s .sleep{position:absolute;top:-4px;right:60px;width:60px;height:4px;border-radius:2px 2px 0px 0px;background:#4D4D4D}.marvel-device.iphone4s .volume{position:absolute;left:-4px;top:160px;height:27px;width:4px;border-radius:2px 0px 0px 2px;background:#4D4D4D}.marvel-device.iphone4s .volume:before{position:absolute;left:0px;top:-70px;height:35px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone4s .volume:after{position:absolute;left:0px;bottom:-64px;height:27px;width:4px;border-radius:2px 0px 0px 2px;background:inherit;content:'';display:block}.marvel-device.iphone4s.landscape{padding:27px 129px;height:320px;width:480px}.marvel-device.iphone4s.landscape .bottom-bar{left:90px;bottom:0px;height:100%;width:3px}.marvel-device.iphone4s.landscape .top-bar{left:calc(100% - 60px);top:0px;height:100%;width:3px}.marvel-device.iphone4s.landscape .camera{top:134px;left:calc(100% - 72px);margin-left:0}.marvel-device.iphone4s.landscape .speaker{top:50%;margin-left:0;margin-top:-32px;left:calc(100% - 72px);width:10px;height:64px}.marvel-device.iphone4s.landscape .sensor{height:40px;width:10px;left:calc(100% - 36px);top:50%;margin-left:0;margin-top:-20px}.marvel-device.iphone4s.landscape .home{left:30px;bottom:50%;margin-left:0;margin-bottom:-36px}.marvel-device.iphone4s.landscape .sleep{height:60px;width:4px;right:-4px;top:calc(100% - 120px);border-radius:0px 2px 2px 0px}.marvel-device.iphone4s.landscape .volume{top:-4px;left:calc(100% - 187px);height:4px;width:27px;border-radius:2px 2px 0px 0px}.marvel-device.iphone4s.landscape .volume:before{right:-70px;left:auto;top:0px;width:35px;height:4px;border-radius:2px 2px 0px 0px}.marvel-device.iphone4s.landscape .volume:after{width:27px;height:4px;bottom:0px;left:-64px;border-radius:2px 2px 0px 0px}.marvel-device.iphone4s.silver{background:#bcbcbc}.marvel-device.iphone4s.silver:before{background:#fcfcfc}.marvel-device.iphone4s.silver .home{background:#fcfcfc;-webkit-box-shadow:inset 0 0 0 1px #bcbcbc;box-shadow:inset 0 0 0 1px #bcbcbc}.marvel-device.iphone4s.silver .home:after{border:1px solid rgba(0,0,0,0.2)}.marvel-device.iphone4s.silver .volume,.marvel-device.iphone4s.silver .sleep{background:#d6d6d6}.marvel-device.nexus5{padding:50px 15px 50px 15px;width:320px;height:568px;background:#1e1e1e;border-radius:20px}.marvel-device.nexus5:before{border-radius:600px / 50px;background:inherit;content:'';top:0;position:absolute;height:103.1%;width:calc(100% - 26px);top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}.marvel-device.nexus5 .top-bar{width:calc(100% - 8px);height:calc(100% - 6px);position:absolute;top:3px;left:4px;border-radius:20px;background:#181818}.marvel-device.nexus5 .top-bar:before{border-radius:600px / 50px;background:inherit;content:'';top:0;position:absolute;height:103.0%;width:calc(100% - 26px);top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}.marvel-device.nexus5 .bottom-bar{display:none}.marvel-device.nexus5 .sleep{width:3px;position:absolute;left:-3px;top:110px;height:100px;background:inherit;border-radius:2px 0px 0px 2px}.marvel-device.nexus5 .volume{width:3px;position:absolute;right:-3px;top:70px;height:45px;background:inherit;border-radius:0px 2px 2px 0px}.marvel-device.nexus5 .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:18px;left:50%;z-index:3;margin-left:-5px;border-radius:100%}.marvel-device.nexus5 .camera:before{background:#3c3d3d;width:6px;height:6px;content:'';display:block;position:absolute;top:2px;left:-100px;z-index:3;border-radius:100%}.marvel-device.nexus5.landscape{padding:15px 50px 15px 50px;height:320px;width:568px}.marvel-device.nexus5.landscape:before{width:103.1%;height:calc(100% - 26px);border-radius:50px / 600px}.marvel-device.nexus5.landscape .top-bar{left:3px;top:4px;height:calc(100% - 8px);width:calc(100% - 6px)}.marvel-device.nexus5.landscape .top-bar:before{width:103%;height:calc(100% - 26px);border-radius:50px / 600px}.marvel-device.nexus5.landscape .sleep{height:3px;width:100px;left:calc(100% - 210px);top:-3px;border-radius:2px 2px 0px 0px}.marvel-device.nexus5.landscape .volume{height:3px;width:45px;right:70px;top:100%;border-radius:0px 0px 2px 2px}.marvel-device.nexus5.landscape .camera{top:50%;left:calc(100% - 18px);margin-left:0;margin-top:-5px}.marvel-device.nexus5.landscape .camera:before{top:-100px;left:2px}.marvel-device.s5{padding:60px 18px;border-radius:42px;width:320px;height:568px;background:#bcbcbc}.marvel-device.s5:before,.marvel-device.s5:after{width:calc(100% - 52px);content:'';display:block;height:26px;background:inherit;position:absolute;border-radius:500px / 40px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.marvel-device.s5:before{top:-7px}.marvel-device.s5:after{bottom:-7px}.marvel-device.s5 .bottom-bar{display:none}.marvel-device.s5 .top-bar{border-radius:37px;width:calc(100% - 10px);height:calc(100% - 10px);top:5px;left:5px;background:radial-gradient(rgba(0,0,0,0.02) 20%, transparent 60%) 0 0,radial-gradient(rgba(0,0,0,0.02) 20%, transparent 60%) 3px 3px;background-color:white;background-size:4px 4px;background-position:center;z-index:2;position:absolute}.marvel-device.s5 .top-bar:before,.marvel-device.s5 .top-bar:after{width:calc(100% - 48px);content:'';display:block;height:26px;background:inherit;position:absolute;border-radius:500px / 40px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.marvel-device.s5 .top-bar:before{top:-7px}.marvel-device.s5 .top-bar:after{bottom:-7px}.marvel-device.s5 .sleep{width:3px;position:absolute;left:-3px;top:100px;height:100px;background:#cecece;border-radius:2px 0px 0px 2px}.marvel-device.s5 .speaker{width:68px;height:8px;position:absolute;top:20px;display:block;z-index:3;left:50%;margin-left:-34px;background-color:#bcbcbc;background-position:top left;border-radius:4px}.marvel-device.s5 .sensor{display:block;position:absolute;top:20px;right:110px;background:#3c3d3d;border-radius:100%;width:8px;height:8px;z-index:3}.marvel-device.s5 .sensor:after{display:block;content:'';position:absolute;top:0px;right:12px;background:#3c3d3d;border-radius:100%;width:8px;height:8px;z-index:3}.marvel-device.s5 .camera{display:block;position:absolute;top:24px;right:42px;background:black;border-radius:100%;width:10px;height:10px;z-index:3}.marvel-device.s5 .camera:before{width:4px;height:4px;background:#3c3d3d;border-radius:100%;position:absolute;content:'';top:50%;left:50%;margin-top:-2px;margin-left:-2px}.marvel-device.s5 .home{position:absolute;z-index:3;bottom:17px;left:50%;width:70px;height:20px;background:white;border-radius:18px;display:block;margin-left:-35px;border:2px solid black}.marvel-device.s5.landscape{padding:18px 60px;height:320px;width:568px}.marvel-device.s5.landscape:before,.marvel-device.s5.landscape:after{height:calc(100% - 52px);width:26px;border-radius:40px / 500px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.marvel-device.s5.landscape:before{top:50%;left:-7px}.marvel-device.s5.landscape:after{top:50%;left:auto;right:-7px}.marvel-device.s5.landscape .top-bar:before,.marvel-device.s5.landscape .top-bar:after{width:26px;height:calc(100% - 48px);border-radius:40px / 500px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.marvel-device.s5.landscape .top-bar:before{right:-7px;top:50%;left:auto}.marvel-device.s5.landscape .top-bar:after{left:-7px;top:50%;right:auto}.marvel-device.s5.landscape .sleep{height:3px;width:100px;left:calc(100% - 200px);top:-3px;border-radius:2px 2px 0px 0px}.marvel-device.s5.landscape .speaker{height:68px;width:8px;left:calc(100% - 20px);top:50%;margin-left:0;margin-top:-34px}.marvel-device.s5.landscape .sensor{right:20px;top:calc(100% - 110px)}.marvel-device.s5.landscape .sensor:after{left:-12px;right:0px}.marvel-device.s5.landscape .camera{top:calc(100% - 42px);right:24px}.marvel-device.s5.landscape .home{width:20px;height:70px;bottom:50%;margin-bottom:-35px;margin-left:0;left:17px}.marvel-device.s5.black{background:#1e1e1e}.marvel-device.s5.black .speaker{background:black}.marvel-device.s5.black .sleep{background:#1e1e1e}.marvel-device.s5.black .top-bar{background:radial-gradient(rgba(0,0,0,0.05) 20%, transparent 60%) 0 0,radial-gradient(rgba(0,0,0,0.05) 20%, transparent 60%) 3px 3px;background-color:#2c2b2c;background-size:4px 4px}.marvel-device.s5.black .home{background:#2c2b2c}.marvel-device.lumia920{padding:80px 35px 125px 35px;background:#ffdd00;width:320px;height:533px;border-radius:40px / 3px}.marvel-device.lumia920 .bottom-bar{display:none}.marvel-device.lumia920 .top-bar{width:calc(100% - 24px);height:calc(100% - 32px);position:absolute;top:16px;left:12px;border-radius:24px;background:black;z-index:1}.marvel-device.lumia920 .top-bar:before{background:#1e1e1e;display:block;content:'';width:calc(100% - 4px);height:calc(100% - 4px);top:2px;left:2px;position:absolute;border-radius:22px}.marvel-device.lumia920 .volume{width:3px;position:absolute;top:130px;height:100px;background:#1e1e1e;right:-3px;border-radius:0px 2px 2px 0px}.marvel-device.lumia920 .volume:before{width:3px;position:absolute;top:190px;content:'';display:block;height:50px;background:inherit;right:0px;border-radius:0px 2px 2px 0px}.marvel-device.lumia920 .volume:after{width:3px;position:absolute;top:460px;content:'';display:block;height:50px;background:inherit;right:0px;border-radius:0px 2px 2px 0px}.marvel-device.lumia920 .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:34px;right:130px;z-index:5;border-radius:5px}.marvel-device.lumia920 .speaker{background:#292728;width:64px;height:10px;position:absolute;top:38px;left:50%;margin-left:-32px;border-radius:5px;z-index:3}.marvel-device.lumia920.landscape{padding:35px 80px 35px 125px;height:320px;width:568px;border-radius:2px / 100px}.marvel-device.lumia920.landscape .top-bar{height:calc(100% - 24px);width:calc(100% - 32px);left:16px;top:12px}.marvel-device.lumia920.landscape .volume{height:3px;right:130px;width:100px;top:100%;border-radius:0px 0px 2px 2px}.marvel-device.lumia920.landscape .volume:before{height:3px;right:190px;top:0px;width:50px;border-radius:0px 0px 2px 2px}.marvel-device.lumia920.landscape .volume:after{height:3px;right:430px;top:0px;width:50px;border-radius:0px 0px 2px 2px}.marvel-device.lumia920.landscape .camera{right:30px;top:calc(100% - 140px)}.marvel-device.lumia920.landscape .speaker{width:10px;height:64px;top:50%;margin-left:0;margin-top:-32px;left:calc(100% - 48px)}.marvel-device.lumia920.black{background:black}.marvel-device.lumia920.white{background:white;-webkit-box-shadow:0 1px 2px 0 rgba(0,0,0,0.2);box-shadow:0 1px 2px 0 rgba(0,0,0,0.2)}.marvel-device.lumia920.blue{background:#00acdd}.marvel-device.lumia920.red{background:#CC3E32}.marvel-device.htc-one{padding:72px 25px 100px 25px;width:320px;height:568px;background:#bebebe;border-radius:34px}.marvel-device.htc-one:before{content:'';display:block;width:calc(100% - 4px);height:calc(100% - 4px);position:absolute;top:2px;left:2px;background:#adadad;border-radius:32px}.marvel-device.htc-one:after{content:'';display:block;width:calc(100% - 8px);height:calc(100% - 8px);position:absolute;top:4px;left:4px;background:#eeeeee;border-radius:30px}.marvel-device.htc-one .top-bar{width:calc(100% - 4px);height:635px;position:absolute;background:#424242;top:50px;z-index:1;left:2px}.marvel-device.htc-one .top-bar:before{content:'';position:absolute;width:calc(100% - 4px);height:100%;position:absolute;background:black;top:0px;z-index:1;left:2px}.marvel-device.htc-one .bottom-bar{display:none}.marvel-device.htc-one .speaker{height:16px;width:216px;display:block;position:absolute;top:22px;z-index:2;left:50%;margin-left:-108px;background:radial-gradient(#343434 25%, transparent 50%) 0 0,radial-gradient(#343434 25%, transparent 50%) 4px 4px;background-size:4px 4px;background-position:top left}.marvel-device.htc-one .speaker:after{content:'';height:16px;width:216px;display:block;position:absolute;top:676px;z-index:2;left:50%;margin-left:-108px;background:inherit}.marvel-device.htc-one .camera{display:block;position:absolute;top:18px;right:38px;background:#3c3d3d;border-radius:100%;width:24px;height:24px;z-index:3}.marvel-device.htc-one .camera:before{width:8px;height:8px;background:black;border-radius:100%;position:absolute;content:'';top:50%;left:50%;margin-top:-4px;margin-left:-4px}.marvel-device.htc-one .sensor{display:block;position:absolute;top:29px;left:60px;background:#3c3d3d;border-radius:100%;width:8px;height:8px;z-index:3}.marvel-device.htc-one .sensor:after{display:block;content:'';position:absolute;top:0px;right:12px;background:#3c3d3d;border-radius:100%;width:8px;height:8px;z-index:3}.marvel-device.htc-one.landscape{padding:25px 72px 25px 100px;height:320px;width:568px}.marvel-device.htc-one.landscape .top-bar{height:calc(100% - 4px);width:635px;left:calc(100% - 685px);top:2px}.marvel-device.htc-one.landscape .speaker{width:16px;height:216px;left:calc(100% - 38px);top:50%;margin-left:0px;margin-top:-108px}.marvel-device.htc-one.landscape .speaker:after{width:16px;height:216px;left:calc(100% - 692px);top:50%;margin-left:0;margin-top:-108px}.marvel-device.htc-one.landscape .camera{right:18px;top:calc(100% - 38px)}.marvel-device.htc-one.landscape .sensor{left:calc(100% - 29px);top:60px}.marvel-device.htc-one.landscape .sensor :after{right:0;top:-12px}.marvel-device.ipad{width:576px;height:768px;padding:90px 25px;background:#242324;border-radius:44px}.marvel-device.ipad:before{width:calc(100% - 8px);height:calc(100% - 8px);position:absolute;content:'';display:block;top:4px;left:4px;border-radius:40px;background:#1e1e1e}.marvel-device.ipad .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:44px;left:50%;margin-left:-5px;border-radius:100%}.marvel-device.ipad .top-bar,.marvel-device.ipad .bottom-bar{display:none}.marvel-device.ipad .home{background:#242324;border-radius:36px;width:50px;height:50px;position:absolute;left:50%;margin-left:-25px;bottom:22px}.marvel-device.ipad .home:after{width:15px;height:15px;margin-top:-8px;margin-left:-8px;border:1px solid rgba(255,255,255,0.1);border-radius:4px;position:absolute;display:block;content:'';top:50%;left:50%}.marvel-device.ipad.landscape{height:576px;width:768px;padding:25px 90px}.marvel-device.ipad.landscape .camera{left:calc(100% - 44px);top:50%;margin-left:0;margin-top:-5px}.marvel-device.ipad.landscape .home{top:50%;left:22px;margin-left:0;margin-top:-25px}.marvel-device.ipad.silver{background:#bcbcbc}.marvel-device.ipad.silver:before{background:#fcfcfc}.marvel-device.ipad.silver .home{background:#fcfcfc;-webkit-box-shadow:inset 0 0 0 1px #bcbcbc;box-shadow:inset 0 0 0 1px #bcbcbc}.marvel-device.ipad.silver .home:after{border:1px solid rgba(0,0,0,0.2)}.marvel-device.macbook{width:960px;height:600px;padding:44px 44px 76px;margin:0 auto;background:#bebebe;border-radius:34px}.marvel-device.macbook:before{width:calc(100% - 8px);height:calc(100% - 8px);position:absolute;content:'';display:block;top:4px;left:4px;border-radius:30px;background:#1e1e1e}.marvel-device.macbook .top-bar{width:calc(100% + 2 * 70px);height:40px;position:absolute;content:'';display:block;top:680px;left:-70px;border-bottom-left-radius:90px 18px;border-bottom-right-radius:90px 18px;background:#bebebe;-webkit-box-shadow:inset 0px -4px 13px 3px rgba(34,34,34,0.6);box-shadow:inset 0px -4px 13px 3px rgba(34,34,34,0.6)}.marvel-device.macbook .top-bar:before{width:100%;height:24px;content:'';display:block;top:0;left:0;background:#f0f0f0;border-bottom:2px solid #aaa;border-radius:5px;position:relative}.marvel-device.macbook .top-bar:after{width:16%;height:14px;content:'';display:block;top:0;background:#ddd;position:absolute;margin-left:auto;margin-right:auto;left:0;right:0;border-radius:0 0 20px 20px;-webkit-box-shadow:inset 0px -3px 10px #999;box-shadow:inset 0px -3px 10px #999}.marvel-device.macbook .bottom-bar{background:transparent;width:calc(100% + 2 * 70px);height:26px;position:absolute;content:'';display:block;top:680px;left:-70px}.marvel-device.macbook .bottom-bar:before,.marvel-device.macbook .bottom-bar:after{height:calc(100% - 2px);width:80px;content:'';display:block;top:0;position:absolute}.marvel-device.macbook .bottom-bar:before{left:0;background:#f0f0f0;background:-webkit-gradient(linear, left top, right top, from(#747474), color-stop(5%, #c3c3c3), color-stop(14%, #ebebeb), color-stop(41%, #979797), color-stop(80%, #f0f0f0), color-stop(100%, #f0f0f0), to(#f0f0f0));background:linear-gradient(to right, #747474 0%, #c3c3c3 5%, #ebebeb 14%, #979797 41%, #f0f0f0 80%, #f0f0f0 100%, #f0f0f0 100%)}.marvel-device.macbook .bottom-bar:after{right:0;background:#f0f0f0;background:-webkit-gradient(linear, left top, right top, from(#f0f0f0), color-stop(0%, #f0f0f0), color-stop(20%, #f0f0f0), color-stop(59%, #979797), color-stop(86%, #ebebeb), color-stop(95%, #c3c3c3), to(#747474));background:linear-gradient(to right, #f0f0f0 0%, #f0f0f0 0%, #f0f0f0 20%, #979797 59%, #ebebeb 86%, #c3c3c3 95%, #747474 100%)}.marvel-device.macbook .camera{background:#3c3d3d;width:10px;height:10px;position:absolute;top:20px;left:50%;margin-left:-5px;border-radius:100%}.marvel-device.macbook .home{display:none}.marvel-device.iphone-x{width:375px;height:812px;padding:26px;background:#fdfdfd;-webkit-box-shadow:inset 0 0 11px 0 black;box-shadow:inset 0 0 11px 0 black;border-radius:66px}.marvel-device.iphone-x .overflow{width:100%;height:100%;position:absolute;top:0;left:0;border-radius:66px;overflow:hidden}.marvel-device.iphone-x .shadow{border-radius:100%;width:90px;height:90px;position:absolute;background:radial-gradient(ellipse at center, rgba(0,0,0,0.6) 0%, rgba(255,255,255,0) 60%)}.marvel-device.iphone-x .shadow--tl{top:-20px;left:-20px}.marvel-device.iphone-x .shadow--tr{top:-20px;right:-20px}.marvel-device.iphone-x .shadow--bl{bottom:-20px;left:-20px}.marvel-device.iphone-x .shadow--br{bottom:-20px;right:-20px}.marvel-device.iphone-x:before{width:calc(100% - 10px);height:calc(100% - 10px);position:absolute;top:5px;content:'';left:5px;border-radius:61px;background:black;z-index:1}.marvel-device.iphone-x .inner-shadow{width:calc(100% - 20px);height:calc(100% - 20px);position:absolute;top:10px;overflow:hidden;left:10px;border-radius:56px;-webkit-box-shadow:inset 0 0 15px 0 rgba(255,255,255,0.66);box-shadow:inset 0 0 15px 0 rgba(255,255,255,0.66);z-index:1}.marvel-device.iphone-x .inner-shadow:before{-webkit-box-shadow:inset 0 0 20px 0 #FFFFFF;box-shadow:inset 0 0 20px 0 #FFFFFF;width:100%;height:116%;position:absolute;top:-8%;content:'';left:0;border-radius:200px / 112px;z-index:2}.marvel-device.iphone-x .screen{border-radius:40px;-webkit-box-shadow:none;box-shadow:none}.marvel-device.iphone-x .top-bar,.marvel-device.iphone-x .bottom-bar{width:100%;position:absolute;height:8px;background:rgba(0,0,0,0.1);left:0}.marvel-device.iphone-x .top-bar{top:80px}.marvel-device.iphone-x .bottom-bar{bottom:80px}.marvel-device.iphone-x .volume,.marvel-device.iphone-x .volume:before,.marvel-device.iphone-x .volume:after,.marvel-device.iphone-x .sleep{width:3px;background:#b5b5b5;position:absolute}.marvel-device.iphone-x .volume{left:-3px;top:116px;height:32px}.marvel-device.iphone-x .volume:before{height:62px;top:62px;content:'';left:0}.marvel-device.iphone-x .volume:after{height:62px;top:140px;content:'';left:0}.marvel-device.iphone-x .sleep{height:96px;top:200px;right:-3px}.marvel-device.iphone-x .camera{width:6px;height:6px;top:9px;border-radius:100%;position:absolute;left:154px;background:#0d4d71}.marvel-device.iphone-x .speaker{height:6px;width:60px;left:50%;position:absolute;top:9px;margin-left:-30px;background:#171818;border-radius:6px}.marvel-device.iphone-x .notch{position:absolute;width:210px;height:30px;top:26px;left:108px;z-index:4;background:black;border-bottom-left-radius:24px;border-bottom-right-radius:24px}.marvel-device.iphone-x .notch:before,.marvel-device.iphone-x .notch:after{content:'';height:8px;position:absolute;top:0;width:8px}.marvel-device.iphone-x .notch:after{background:radial-gradient(circle at bottom left, transparent 0, transparent 70%, black 70%, black 100%);left:-8px}.marvel-device.iphone-x .notch:before{background:radial-gradient(circle at bottom right, transparent 0, transparent 70%, black 70%, black 100%);right:-8px}.marvel-device.iphone-x.landscape{height:375px;width:812px}.marvel-device.iphone-x.landscape .top-bar,.marvel-device.iphone-x.landscape .bottom-bar{width:8px;height:100%;top:0}.marvel-device.iphone-x.landscape .top-bar{left:80px}.marvel-device.iphone-x.landscape .bottom-bar{right:80px;bottom:auto;left:auto}.marvel-device.iphone-x.landscape .volume,.marvel-device.iphone-x.landscape .volume:before,.marvel-device.iphone-x.landscape .volume:after,.marvel-device.iphone-x.landscape .sleep{height:3px}.marvel-device.iphone-x.landscape .inner-shadow:before{height:100%;width:116%;left:-8%;top:0;border-radius:112px / 200px}.marvel-device.iphone-x.landscape .volume{bottom:-3px;top:auto;left:116px;width:32px}.marvel-device.iphone-x.landscape .volume:before{width:62px;left:62px;top:0}.marvel-device.iphone-x.landscape .volume:after{width:62px;left:140px;top:0}.marvel-device.iphone-x.landscape .sleep{width:96px;left:200px;top:-3px;right:auto}.marvel-device.iphone-x.landscape .camera{left:9px;bottom:154px;top:auto}.marvel-device.iphone-x.landscape .speaker{width:6px;height:60px;left:9px;top:50%;margin-top:-30px;margin-left:0}.marvel-device.iphone-x.landscape .notch{height:210px;width:30px;left:26px;bottom:108px;top:auto;border-top-right-radius:24px;border-bottom-right-radius:24px;border-bottom-left-radius:0}.marvel-device.iphone-x.landscape .notch:before,.marvel-device.iphone-x.landscape .notch:after{left:0}.marvel-device.iphone-x.landscape .notch:after{background:radial-gradient(circle at bottom right, transparent 0, transparent 70%, black 70%, black 100%);bottom:-8px;top:auto}.marvel-device.iphone-x.landscape .notch:before{background:radial-gradient(circle at top right, transparent 0, transparent 70%, black 70%, black 100%);top:-8px}.marvel-device.note8{width:400px;height:822px;background:black;border-radius:34px;padding:45px 10px}.marvel-device.note8 .overflow{width:100%;height:100%;position:absolute;top:0;left:0;border-radius:34px;overflow:hidden}.marvel-device.note8 .speaker{height:8px;width:56px;left:50%;position:absolute;top:25px;margin-left:-28px;background:#171818;z-index:1;border-radius:8px}.marvel-device.note8 .camera{height:18px;width:18px;left:86px;position:absolute;top:18px;background:#212b36;z-index:1;border-radius:100%}.marvel-device.note8 .camera:before{content:'';height:8px;width:8px;left:-22px;position:absolute;top:5px;background:#212b36;z-index:1;border-radius:100%}.marvel-device.note8 .sensors{height:10px;width:10px;left:120px;position:absolute;top:22px;background:#1d233b;z-index:1;border-radius:100%}.marvel-device.note8 .sensors:before{content:'';height:10px;width:10px;left:18px;position:absolute;top:0;background:#1d233b;z-index:1;border-radius:100%}.marvel-device.note8 .more-sensors{height:16px;width:16px;left:285px;position:absolute;top:18px;background:#33244a;-webkit-box-shadow:0 0 0 2px rgba(255,255,255,0.1);box-shadow:0 0 0 2px rgba(255,255,255,0.1);z-index:1;border-radius:100%}.marvel-device.note8 .more-sensors:before{content:'';height:11px;width:11px;left:40px;position:absolute;top:4px;background:#214a61;z-index:1;border-radius:100%}.marvel-device.note8 .sleep{width:2px;height:56px;background:black;position:absolute;top:288px;right:-2px}.marvel-device.note8 .volume{width:2px;height:120px;background:black;position:absolute;top:168px;left:-2px}.marvel-device.note8 .volume:before{content:'';top:168px;width:2px;position:absolute;left:0;background:black;height:56px}.marvel-device.note8 .inner{width:100%;height:calc(100% - 8px);position:absolute;top:2px;content:'';left:0px;border-radius:34px;border-top:2px solid #9fa0a2;border-bottom:2px solid #9fa0a2;background:black;z-index:1;-webkit-box-shadow:inset 0 0 6px 0 rgba(255,255,255,0.5);box-shadow:inset 0 0 6px 0 rgba(255,255,255,0.5)}.marvel-device.note8 .shadow{-webkit-box-shadow:inset 0 0 60px 0 white,inset 0 0 30px 0 rgba(255,255,255,0.5),0 0 20px 0 white,0 0 20px 0 rgba(255,255,255,0.5);box-shadow:inset 0 0 60px 0 white,inset 0 0 30px 0 rgba(255,255,255,0.5),0 0 20px 0 white,0 0 20px 0 rgba(255,255,255,0.5);height:101%;position:absolute;top:-0.5%;content:'';width:calc(100% - 20px);left:10px;border-radius:38px;z-index:5;pointer-events:none}.marvel-device.note8 .screen{border-radius:14px;-webkit-box-shadow:none;box-shadow:none}.marvel-device.note8.landscape{height:400px;width:822px;padding:10px 45px}.marvel-device.note8.landscape .speaker{height:56px;width:8px;top:50%;margin-top:-28px;margin-left:0;right:25px;left:auto}.marvel-device.note8.landscape .camera{top:86px;right:18px;left:auto}.marvel-device.note8.landscape .camera:before{top:-22px;left:5px}.marvel-device.note8.landscape .sensors{top:120px;right:22px;left:auto}.marvel-device.note8.landscape .sensors:before{top:18px;left:0}.marvel-device.note8.landscape .more-sensors{top:285px;right:18px;left:auto}.marvel-device.note8.landscape .more-sensors:before{top:40px;left:4px}.marvel-device.note8.landscape .sleep{bottom:-2px;top:auto;right:288px;width:56px;height:2px}.marvel-device.note8.landscape .volume{width:120px;height:2px;top:-2px;right:168px;left:auto}.marvel-device.note8.landscape .volume:before{right:168px;left:auto;top:0;width:56px;height:2px}.marvel-device.note8.landscape .inner{height:100%;width:calc(100% - 8px);left:2px;top:0;border-top:0;border-bottom:0;border-left:2px solid #9fa0a2;border-right:2px solid #9fa0a2}.marvel-device.note8.landscape .shadow{width:101%;height:calc(100% - 20px);left:-0.5%;top:10px}
.egkRpC {
    width: 424px;
    height: 660px;
    background-image: url("data:image/svg+xml,<%3fxml version='1.0' encoding='UTF-8'%3f> <svg width='422px' height='850px' viewBox='0 0 422 850' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> <!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch --> <title>preview-iphone</title> <desc>Created with Sketch.</desc> <defs> <path d='M53.4888889%2c0 L361.511111%2c0 C391.052209%2c-4.53449045e-14 415%2c24.2553427 415%2c54.1758242 L415%2c795.824176 C415%2c825.744657 391.052209%2c850 361.511111%2c850 L53.4888889%2c850 C23.9477913%2c850 3.2763915e-15%2c825.744657 0%2c795.824176 L0%2c54.1758242 C-3.68594044e-15%2c24.2553427 23.9477913%2c5.49630329e-15 53.4888889%2c0 Z' id='path-1'></path> <path d='M101.832692%2c20 L54.9458128%2c20 C37.0439453%2c20 24%2c33.2322544 24%2c50.5143838 L24%2c787.500376 C24%2c810.034354 44.1552734%2c830 66.9458128%2c830 L356.054187%2c830 C378.007813%2c830 399%2c809.879271 399%2c787.500376 L399%2c52.5119237 C399%2c31.7980569 384.830078%2c20.1231808 368.054187%2c20 L319.268428%2c20 C318.806692%2c20.0821205 317.237128%2c20.1231808 316.559739%2c20.1231808 C312.02832%2c20.1231808 310.578149%2c24.0614045 310.578149%2c33.2322544 C310.578149%2c42.4031044 299.921875%2c50.1529901 292.128242%2c50.1529901 L260.453202%2c50.1529901 L143.175012%2c50.1529901 L129.582031%2c50.1529901 C125.877348%2c50.1529901 112.289529%2c45.8831632 111.185547%2c33.2322544 C110.081565%2c20.5813456 109.924636%2c20.1231808 103.541381%2c20.1231808 C102.863991%2c20.1231808 102.294428%2c20.0821205 101.832692%2c20 Z' id='path-2'></path> </defs> <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <g id='preview-iphone'> <g transform='translate(-0.500000%2c 0.000000)'> <g id='controls' transform='translate(0.500000%2c 112.000000)' fill='%23EBEBEB'> <rect id='silent' x='0' y='0' width='8' height='34' rx='2'></rect> <rect id='vol%2b' x='0' y='60' width='8' height='64' rx='2'></rect> <rect id='power' x='414' y='40' width='8' height='80' rx='2'></rect> <rect id='vol-' x='0' y='140' width='8' height='64' rx='2'></rect> </g> <g id='phone' transform='translate(4.000000%2c 0.000000)'> <g id='body'> <use fill='white' fill-rule='evenodd' xlink:href='%23path-1'></use> <path stroke='%23F2F2F2' stroke-width='2.5' d='M53.4888889%2c1.25 C24.6417429%2c1.25 1.25%2c24.9421533 1.25%2c54.1758242 L1.25%2c795.824176 C1.25%2c825.057847 24.6417429%2c848.75 53.4888889%2c848.75 L361.511111%2c848.75 C390.358257%2c848.75 413.75%2c825.057847 413.75%2c795.824176 L413.75%2c54.1758242 C413.75%2c24.9421533 390.358257%2c1.25 361.511111%2c1.25 L53.4888889%2c1.25 Z'></path> </g> <path d='M362.862669%2c831.108398 L52.1373309%2c831.108398 C37.0444336%2c831.764648 24.0317383%2c837.443848 13.8237305%2c848.87793 C21.7026945%2c842.297818 33.9319006%2c834.723047 52.5112799%2c834.723047 C250.905405%2c834.723047 354.231218%2c834.723047 362.48872%2c834.723047 C381.068099%2c834.723047 394.404727%2c843.419888 402.283691%2c850 C391.620605%2c837.710449 378.31543%2c831.726074 362.862669%2c831.108398 Z' id='reflect-frame-bottom-2' fill-opacity='0.649999976' fill='%23F2F2F2' transform='translate(208.053711%2c 840.554199) scale(1%2c -1) translate(-208.053711%2c -840.554199) '></path> <path d='M399.038672%2c847.233301 C390.20261%2c840.906031 379.375659%2c837.181865 367.678883%2c837.181865 L50.7876462%2c837.181865 C37.487023%2c837.181865 25.3111183%2c841.997357 15.9082736%2c849.98 C25.773567%2c839.107453 40.0164866%2c832.279717 55.8541093%2c832.279717 L361.76801%2c832.279717 C376.226385%2c832.279717 389.355717%2c837.970024 399.038672%2c847.233301 Z' id='reflect-frame-bottom' fill='%23F2F2F2' transform='translate(207.473473%2c 841.129858) scale(1%2c -1) translate(-207.473473%2c -841.129858) '></path> <circle id='oval' fill='%23EBEBEB' cx='134' cy='31' r='5.71428571'></circle> <circle id='oval' fill='%23EBEBEB' cx='165' cy='31' r='5.71428571'></circle> <circle id='oval' fill='%23EBEBEB' cx='247' cy='31' r='3.57142857'></circle> <circle id='oval' fill='%23EBEBEB' cx='279' cy='31' r='8'></circle> <rect id='earpiece' fill='%23EBEBEB' transform='translate(207.500000%2c 31.500000) scale(-1%2c 1) translate(-207.500000%2c -31.500000) ' x='185' y='28' width='45' height='7' rx='3.5'></rect> </g> <mask id='mask-3' fill='white'> <use xlink:href='%23path-2'></use> </mask> <g id='Screen-Mask'> <use fill='%23F7F7F7' fill-rule='evenodd' xlink:href='%23path-2'></use> <path stroke='%23EBEBEB' stroke-width='2.5' d='M102.051571%2c18.7693125 C102.433434%2c18.8372274 102.932158%2c18.8731808 103.541381%2c18.8731808 C110.737427%2c18.8731808 111.267735%2c19.7954627 112.430814%2c33.1235861 C112.889227%2c38.3766923 115.680199%2c42.4671332 120.098914%2c45.394665 C123.36085%2c47.5557957 127.443389%2c48.9029901 129.582031%2c48.9029901 L143.175012%2c48.9029901 L292.128242%2c48.9029901 C300.029619%2c48.9029901 309.328149%2c41.0214848 309.328149%2c33.2322544 C309.328149%2c23.1384766 311.187603%2c18.8731808 316.559739%2c18.8731808 C317.407785%2c18.8731808 318.756699%2c18.8213963 319.049549%2c18.7693125 L319.268428%2c18.75 L368.063365%2c18.7500337 C386.651581%2c18.8865219 400.25%2c32.204949 400.25%2c52.5119237 L400.25%2c787.500376 C400.25%2c810.356097 378.91645%2c831.25 356.054187%2c831.25 L66.9458128%2c831.25 C43.4745341%2c831.25 22.75%2c810.73429 22.75%2c787.500376 L22.75%2c50.5143838 C22.75%2c32.4101432 36.4860588%2c18.75 54.9458128%2c18.75 L101.832692%2c18.75 L102.051571%2c18.7693125 Z'></path> </g> <g id='Screen' mask='url(%23mask-3)' fill='%23E3E3E3'> <g transform='translate(118.000000%2c 137.000000)'> <path d='M6.96927741%2c93 L5.03568366%2c93 L5.03568366%2c79.2392578 L0.147988349%2c79.2392578 L0.147988349%2c77.4990234 L11.8569727%2c77.4990234 L11.8569727%2c79.2392578 L6.96927741%2c79.2392578 L6.96927741%2c93 Z M20.6847852%2c81.828125 L20.6847852%2c93 L18.9123243%2c93 L18.9123243%2c91.1845703 L18.8693555%2c91.1845703 C18.2033399%2c92.4736328 17.0431837%2c93.1933594 15.3244337%2c93.1933594 C12.8859571%2c93.1933594 11.4572462%2c91.6142578 11.4572462%2c89.0791016 L11.4572462%2c81.828125 L13.3263868%2c81.828125 L13.3263868%2c88.7460938 C13.3263868%2c90.5615234 14.1750196%2c91.5390625 15.9045118%2c91.5390625 C17.7199415%2c91.5390625 18.8156446%2c90.2929688 18.8156446%2c88.3916016 L18.8156446%2c81.828125 L20.6847852%2c81.828125 Z M27.9012696%2c83.2568359 C26.150293%2c83.2568359 24.9256836%2c84.5996094 24.8075196%2c86.4580078 L30.8768555%2c86.4580078 C30.8338868%2c84.5888672 29.6629883%2c83.2568359 27.9012696%2c83.2568359 Z M30.8338868%2c89.7988281 L32.6708008%2c89.7988281 C32.3485352%2c91.7539062 30.4579102%2c93.1933594 28.0194336%2c93.1933594 C24.8182618%2c93.1933594 22.8739258%2c90.9697266 22.8739258%2c87.4570312 C22.8739258%2c83.9873047 24.8504883%2c81.6347656 27.9334961%2c81.6347656 C30.9520508%2c81.6347656 32.8104493%2c83.8261719 32.8104493%2c87.2099609 L32.8104493%2c87.9189453 L24.7967774%2c87.9189453 L24.7967774%2c88.0263672 C24.7967774%2c90.1640625 26.0536133%2c91.5712891 28.0624024%2c91.5712891 C29.4803711%2c91.5712891 30.5223633%2c90.8515625 30.8338868%2c89.7988281 Z M34.8169727%2c84.9111328 C34.8169727%2c82.9990234 36.5249805%2c81.6347656 38.9849415%2c81.6347656 C41.2945118%2c81.6347656 42.9917774%2c83.0097656 43.0777149%2c84.9003906 L41.2945118%2c84.9003906 C41.1656055%2c83.8261719 40.2954883%2c83.1601562 38.9204883%2c83.1601562 C37.5562305%2c83.1601562 36.6538868%2c83.8369141 36.6538868%2c84.8144531 C36.6538868%2c85.5878906 37.2447071%2c86.1035156 38.5122852%2c86.4257812 L40.2417774%2c86.8447266 C42.4976368%2c87.4140625 43.314043%2c88.2304688 43.314043%2c89.8740234 C43.314043%2c91.8183594 41.477129%2c93.1933594 38.8667774%2c93.1933594 C36.4175586%2c93.1933594 34.7095508%2c91.8613281 34.5161915%2c89.8847656 L36.3853321%2c89.8847656 C36.5894336%2c91.0449219 37.470293%2c91.6679688 38.9849415%2c91.6679688 C40.4995899%2c91.6679688 41.4341602%2c91.0234375 41.4341602%2c90.0136719 C41.4341602%2c89.21875 40.9722461%2c88.7890625 39.7154102%2c88.4560547 L37.7495899%2c87.9511719 C35.7837696%2c87.4462891 34.8169727%2c86.4365234 34.8169727%2c84.9111328 Z M49.8000586%2c93.1933594 C46.9533789%2c93.1933594 45.0197852%2c90.9160156 45.0197852%2c87.4140625 C45.0197852%2c83.9121094 46.9426368%2c81.6347656 49.7570899%2c81.6347656 C51.3576758%2c81.6347656 52.6467383%2c82.4189453 53.3127539%2c83.6435547 L53.3557227%2c83.6435547 L53.3557227%2c77.4990234 L55.2248633%2c77.4990234 L55.2248633%2c93 L53.4416602%2c93 L53.4416602%2c91.109375 L53.4094336%2c91.109375 C52.6897071%2c92.3984375 51.4113868%2c93.1933594 49.8000586%2c93.1933594 Z M50.1545508%2c83.2783203 C48.1779883%2c83.2783203 46.9318946%2c84.8896484 46.9318946%2c87.4140625 C46.9318946%2c89.9492188 48.1779883%2c91.5498047 50.1545508%2c91.5498047 C52.0774024%2c91.5498047 53.3664649%2c89.9169922 53.3664649%2c87.4140625 C53.3664649%2c84.921875 52.0774024%2c83.2783203 50.1545508%2c83.2783203 Z M61.7538477%2c91.6035156 C63.5155664%2c91.6035156 64.8690821%2c90.3681641 64.8690821%2c88.7568359 L64.8690821%2c87.84375 L61.8827539%2c88.0263672 C60.3788477%2c88.1230469 59.5194727%2c88.7890625 59.5194727%2c89.8417969 C59.5194727%2c90.9052734 60.4110743%2c91.6035156 61.7538477%2c91.6035156 Z M61.3349024%2c93.1933594 C59.1112696%2c93.1933594 57.6181055%2c91.8505859 57.6181055%2c89.8417969 C57.6181055%2c87.9296875 59.0897852%2c86.7265625 61.6679102%2c86.5761719 L64.8690821%2c86.3935547 L64.8690821%2c85.4589844 C64.8690821%2c84.0947266 63.9667383%2c83.2783203 62.4198633%2c83.2783203 C60.9804102%2c83.2783203 60.0780664%2c83.9550781 59.8417383%2c85.0507812 L58.0370508%2c85.0507812 C58.1659571%2c83.1171875 59.8202539%2c81.6347656 62.4628321%2c81.6347656 C65.0839258%2c81.6347656 66.7382227%2c83.0527344 66.7382227%2c85.2763672 L66.7382227%2c93 L64.9657618%2c93 L64.9657618%2c91.0771484 L64.922793%2c91.0771484 C64.2567774%2c92.3554688 62.8388086%2c93.1933594 61.3349024%2c93.1933594 Z M70.3560742%2c97.1787109 C70.1304883%2c97.1787109 69.7545117%2c97.1572266 69.5504102%2c97.1142578 L69.5504102%2c95.5458984 C69.7545117%2c95.5888672 70.0445508%2c95.5996094 70.2808789%2c95.5996094 C71.3228711%2c95.5996094 71.9029492%2c95.0947266 72.3326367%2c93.7949219 L72.5904492%2c93.0107422 L68.4654492%2c81.828125 L70.4634961%2c81.828125 L73.5572461%2c91.1308594 L73.5894727%2c91.1308594 L76.6832227%2c81.828125 L78.649043%2c81.828125 L74.2554883%2c93.7841797 C73.2994336%2c96.3945312 72.3756055%2c97.1787109 70.3560742%2c97.1787109 Z M80.1077149%2c96.0830078 L78.5500977%2c96.0830078 L79.5920899%2c90.6152344 L81.5793945%2c90.6152344 L80.1077149%2c96.0830078 Z M95.3248633%2c77.2412109 C99.718418%2c77.2412109 102.468418%2c80.3349609 102.468418%2c85.2548828 C102.468418%2c90.1748047 99.718418%2c93.2578125 95.3248633%2c93.2578125 C90.9313086%2c93.2578125 88.1813086%2c90.1748047 88.1813086%2c85.2548828 C88.1813086%2c80.3349609 90.9313086%2c77.2412109 95.3248633%2c77.2412109 Z M95.3248633%2c79.0244141 C92.155918%2c79.0244141 90.1686133%2c81.4306641 90.1686133%2c85.2548828 C90.1686133%2c89.0683594 92.155918%2c91.4746094 95.3248633%2c91.4746094 C98.4938086%2c91.4746094 100.481113%2c89.0683594 100.481113%2c85.2548828 C100.481113%2c81.4306641 98.4938086%2c79.0244141 95.3248633%2c79.0244141 Z M114.185879%2c85.4912109 L112.359707%2c85.4912109 C112.091152%2c84.2773438 111.14584%2c83.2783203 109.502285%2c83.2783203 C107.568691%2c83.2783203 106.258145%2c84.8789062 106.258145%2c87.4140625 C106.258145%2c90.0136719 107.590176%2c91.5498047 109.52377%2c91.5498047 C111.04916%2c91.5498047 112.048184%2c90.7441406 112.370449%2c89.4013672 L114.207363%2c89.4013672 C113.917324%2c91.625 112.048184%2c93.1933594 109.513027%2c93.1933594 C106.419277%2c93.1933594 104.356777%2c91.0126953 104.356777%2c87.4140625 C104.356777%2c83.890625 106.408535%2c81.6347656 109.491543%2c81.6347656 C112.284512%2c81.6347656 113.949551%2c83.4824219 114.185879%2c85.4912109 Z M116.847676%2c79.1318359 L118.716816%2c79.1318359 L118.716816%2c81.828125 L120.886738%2c81.828125 L120.886738%2c83.3642578 L118.716816%2c83.3642578 L118.716816%2c90.0029297 C118.716816%2c91.0234375 119.146504%2c91.4853516 120.102559%2c91.4853516 C120.317402%2c91.4853516 120.74709%2c91.453125 120.875996%2c91.4316406 L120.875996%2c93 C120.65041%2c93.0537109 120.134785%2c93.0859375 119.694355%2c93.0859375 C117.642598%2c93.0859375 116.847676%2c92.2480469 116.847676%2c90.0996094 L116.847676%2c83.3642578 L115.182637%2c83.3642578 L115.182637%2c81.828125 L116.847676%2c81.828125 L116.847676%2c79.1318359 Z M127.50166%2c93.1933594 C124.40791%2c93.1933594 122.323926%2c90.9697266 122.323926%2c87.4140625 C122.323926%2c83.8476562 124.40791%2c81.6347656 127.50166%2c81.6347656 C130.584668%2c81.6347656 132.668652%2c83.8476562 132.668652%2c87.4140625 C132.668652%2c90.9697266 130.584668%2c93.1933594 127.50166%2c93.1933594 Z M127.50166%2c91.5498047 C129.478223%2c91.5498047 130.767285%2c90.0458984 130.767285%2c87.4140625 C130.767285%2c84.7822266 129.478223%2c83.2783203 127.50166%2c83.2783203 C125.525098%2c83.2783203 124.225293%2c84.7822266 124.225293%2c87.4140625 C124.225293%2c90.0458984 125.525098%2c91.5498047 127.50166%2c91.5498047 Z M140.422246%2c93.1933594 C138.789434%2c93.1933594 137.511113%2c92.3984375 136.791387%2c91.109375 L136.748418%2c91.109375 L136.748418%2c93 L134.965215%2c93 L134.965215%2c77.4990234 L136.834355%2c77.4990234 L136.834355%2c83.6972656 L136.877324%2c83.6972656 C137.575566%2c82.4189453 138.875371%2c81.6347656 140.454473%2c81.6347656 C143.268926%2c81.6347656 145.170293%2c83.9121094 145.170293%2c87.4140625 C145.170293%2c90.9267578 143.279668%2c93.1933594 140.422246%2c93.1933594 Z M140.057012%2c83.2783203 C138.166387%2c83.2783203 136.823613%2c84.9326172 136.823613%2c87.4140625 C136.823613%2c89.90625 138.166387%2c91.5498047 140.057012%2c91.5498047 C142.033574%2c91.5498047 143.258184%2c89.9707031 143.258184%2c87.4140625 C143.258184%2c84.8789062 142.033574%2c83.2783203 140.057012%2c83.2783203 Z M151.86041%2c83.2568359 C150.109434%2c83.2568359 148.884824%2c84.5996094 148.76666%2c86.4580078 L154.835996%2c86.4580078 C154.793027%2c84.5888672 153.622129%2c83.2568359 151.86041%2c83.2568359 Z M154.793027%2c89.7988281 L156.629941%2c89.7988281 C156.307676%2c91.7539062 154.417051%2c93.1933594 151.978574%2c93.1933594 C148.777402%2c93.1933594 146.833066%2c90.9697266 146.833066%2c87.4570312 C146.833066%2c83.9873047 148.809629%2c81.6347656 151.892637%2c81.6347656 C154.911191%2c81.6347656 156.76959%2c83.8261719 156.76959%2c87.2099609 L156.76959%2c87.9189453 L148.755918%2c87.9189453 L148.755918%2c88.0263672 C148.755918%2c90.1640625 150.012754%2c91.5712891 152.021543%2c91.5712891 C153.439512%2c91.5712891 154.481504%2c90.8515625 154.793027%2c89.7988281 Z M158.969473%2c93 L158.969473%2c81.828125 L160.731191%2c81.828125 L160.731191%2c83.6542969 L160.77416%2c83.6542969 C161.139394%2c82.4189453 162.170644%2c81.6347656 163.481191%2c81.6347656 C163.803457%2c81.6347656 164.082754%2c81.6884766 164.233144%2c81.7099609 L164.233144%2c83.5253906 C164.082754%2c83.4716797 163.685293%2c83.4179688 163.234121%2c83.4179688 C161.783926%2c83.4179688 160.838613%2c84.4599609 160.838613%2c86.0390625 L160.838613%2c93 L158.969473%2c93 Z M174.895605%2c93 L174.895605%2c79.5507812 L174.852637%2c79.5507812 L170.749121%2c82.5048828 L170.749121%2c80.4638672 L174.874121%2c77.4990234 L176.764746%2c77.4990234 L176.764746%2c93 L174.895605%2c93 Z M188.385527%2c93 L188.385527%2c89.7773438 L180.597441%2c89.7773438 L180.597441%2c88.0263672 C181.91873%2c85.5771484 183.73416%2c82.7519531 187.397246%2c77.4990234 L190.254668%2c77.4990234 L190.254668%2c88.0800781 L192.446074%2c88.0800781 L192.446074%2c89.7773438 L190.254668%2c89.7773438 L190.254668%2c93 L188.385527%2c93 Z M182.509551%2c88.0371094 L182.509551%2c88.0800781 L188.385527%2c88.0800781 L188.385527%2c79.1103516 L188.353301%2c79.1103516 C185.420684%2c83.2998047 183.73416%2c85.8886719 182.509551%2c88.0371094 Z' id='Tuesday%2c-October-14'></path> <path d='M38.1037938%2c57 L38.1037938%2c4.109375 L38.0256688%2c4.109375 C35.1350438%2c5.8671875 26.4241063%2c11.6484375 22.6350438%2c14.03125 L22.6350438%2c10.59375 C26.2287938%2c8.328125 34.1975438%2c2.9765625 38.1037938%2c0.6328125 L41.1506688%2c0.6328125 L41.1506688%2c57 L38.1037938%2c57 Z M69.4263388%2c57 L69.4263388%2c4.109375 L69.3482138%2c4.109375 C66.4575888%2c5.8671875 57.7466513%2c11.6484375 53.9575888%2c14.03125 L53.9575888%2c10.59375 C57.5513388%2c8.328125 65.5200888%2c2.9765625 69.4263388%2c0.6328125 L72.4732138%2c0.6328125 L72.4732138%2c57 L69.4263388%2c57 Z M89.5770088%2c46.8046875 C88.1316963%2c46.8046875 86.9598213%2c45.6328125 86.9598213%2c44.1875 C86.9598213%2c42.78125 88.1316963%2c41.609375 89.5770088%2c41.609375 C90.9832588%2c41.609375 92.1551338%2c42.78125 92.1551338%2c44.1875 C92.1551338%2c45.6328125 90.9832588%2c46.8046875 89.5770088%2c46.8046875 Z M89.5770088%2c16.53125 C88.1316963%2c16.53125 86.9598213%2c15.359375 86.9598213%2c13.9140625 C86.9598213%2c12.5078125 88.1316963%2c11.3359375 89.5770088%2c11.3359375 C90.9832588%2c11.3359375 92.1551338%2c12.5078125 92.1551338%2c13.9140625 C92.1551338%2c15.359375 90.9832588%2c16.53125 89.5770088%2c16.53125 Z M118.087054%2c57 L118.087054%2c4.109375 L118.008929%2c4.109375 C115.118304%2c5.8671875 106.407366%2c11.6484375 102.618304%2c14.03125 L102.618304%2c10.59375 C106.212054%2c8.328125 114.180804%2c2.9765625 118.087054%2c0.6328125 L121.133929%2c0.6328125 L121.133929%2c57 L118.087054%2c57 Z M139.526786%2c57 L166.479911%2c3.5625 L166.479911%2c3.4453125 L133.706474%2c3.4453125 L133.706474%2c0.6328125 L169.643974%2c0.6328125 L169.643974%2c3.6015625 L142.886161%2c57 L139.526786%2c57 Z' id='11:17'></path> </g> </g> <g id='status-bar' mask='url(%23mask-3)'> <g transform='translate(23.000000%2c 24.000000)'> <rect id='bounds' fill='none' x='0' y='0' width='375' height='20'></rect> <g id='battery-fixed' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(337.000000%2c 11.500000)'> <rect id='inside' fill='%23EBEBEB' x='2' y='2.75' width='18' height='7.5' rx='1'></rect> <path d='M23%2c4.56300874 C23.8626136%2c4.78503014 24.5%2c5.56808029 24.5%2c6.5 C24.5%2c7.43191971 23.8626136%2c8.21496986 23%2c8.43699126 L23%2c4.56300874 Z' id='side' fill='%23EBEBEB'></path> <path d='M2%2c0.75 L20%2c0.75 C21.1045695%2c0.75 22%2c1.6454305 22%2c2.75 L22%2c10.25 C22%2c11.3545695 21.1045695%2c12.25 20%2c12.25 L2%2c12.25 C0.8954305%2c12.25 -8.67738547e-17%2c11.3545695 -2.22044605e-16%2c10.25 L-2.22044605e-16%2c2.75 C-3.57315355e-16%2c1.6454305 0.8954305%2c0.75 2%2c0.75 Z M1.91666667%2c1.75 C1.36438192%2c1.75 0.916666667%2c2.19771525 0.916666667%2c2.75 L0.916666667%2c10.25 C0.916666667%2c10.8022847 1.36438192%2c11.25 1.91666667%2c11.25 L20.0833333%2c11.25 C20.6356181%2c11.25 21.0833333%2c10.8022847 21.0833333%2c10.25 L21.0833333%2c2.75 C21.0833333%2c2.19771525 20.6356181%2c1.75 20.0833333%2c1.75 L1.91666667%2c1.75 Z' id='frame' fill='%23EBEBEB'></path> </g> <path d='M317%2c16.0755358 C318.900223%2c14.1753125 321.525357%2c13 324.425%2c13 C327.324643%2c13 329.949777%2c14.1753125 331.85%2c16.0755358 L330.677632%2c17.2479042 C329.077444%2c15.6477162 326.866805%2c14.6579794 324.425%2c14.6579794 C321.983196%2c14.6579794 319.772556%2c15.6477162 318.172368%2c17.2479042 L317%2c16.0755358 Z M319.344737%2c18.4202727 C320.64489%2c17.1201199 322.441034%2c16.3159587 324.425%2c16.3159587 C326.408966%2c16.3159587 328.205111%2c17.1201199 329.505263%2c18.4202727 L328.332895%2c19.5926411 C327.332778%2c18.5925236 325.951128%2c17.9739381 324.425%2c17.9739381 C322.898872%2c17.9739381 321.517223%2c18.5925236 320.517105%2c19.5926411 L319.344737%2c18.4202727 Z M321.689474%2c20.7650096 C322.389556%2c20.0649273 323.356711%2c19.6319175 324.425%2c19.6319175 C325.49329%2c19.6319175 326.460444%2c20.0649273 327.160527%2c20.7650096 L324.425%2c23.500536 L321.689474%2c20.7650096 Z' id='wifi' fill='%23EBEBEB' fill-rule='evenodd'></path> <g id='signal' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(295.000000%2c 13.250000)'> <rect id='4' fill='%23EBEBEB' x='13.5' y='0' width='3' height='10' rx='1'></rect> <rect id='3' fill='%23EBEBEB' x='9' y='2' width='3' height='8' rx='1'></rect> <rect id='2' fill='%23EBEBEB' x='4.5' y='4' width='3' height='6' rx='1'></rect> <rect id='1' fill='%23EBEBEB' x='0' y='6' width='3' height='4' rx='1'></rect> </g> </g> </g> </g> </g> </g> </svg>");
    background-size: cover;
    overflow-y: hidden;
    overflow-x: hidden;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    background-repeat: no-repeat;
    margin: 0px auto;
}
@media(max-width:800px){
    .desktop_only {
        display: none;
    }
    .movil_only {
        margin-top:20px;
    }
}
@media(min-width:800px){
    .movil_only {
        display:none;
    }
}
.dSmbrN {
    position: relative;
    top: 250px;
    left: 32px;
    cursor: pointer;
}
.hQVZHz {
    box-shadow: rgb(212, 212, 213) 0px 1px 3px 0px;
    max-width: 360px;
    background-color: rgb(255, 255, 255);
    overflow-y: hidden;
    border-radius: 10px;
}
.dgBCNv {
    width: 360px;
    box-shadow: rgb(212, 212, 213) 0px 1px 3px 0px;
    margin-top: 10px;
    border-radius: 10px;
}
.jiSlDO {
    color: rgb(85, 85, 85);
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-weight: 300;
    text-align: center;
    line-height: 20px;
    padding: 10px 10px 8px;
    border-bottom: none;
    border-radius: 10px 10px 0px 0px;
}
.eLaYeg {
    max-height: 350px;
    overflow-y: auto;
}
.bFdPyK:last-child {
    border-radius: 0px 0px 10px 10px;
    border-bottom: none;
}
.bFdPyK:first-child {
    border-radius: 10px 10px 0px 0px;
}
.bFdPyK {
    background-color: rgba(255, 255, 255, 0.3);
    width: 100%;
    text-align: center;
    padding: 15px 0px;
    border-bottom: 1px solid rgb(221, 221, 221);
}
.sc-fMiknA.enniBG {
    padding: 10px;
    padding-top: 5px;
}

.sc-fBuWsC.jLtcjp {
    padding: 10px;
    padding-bottom: 0px;
}
*, *:before, *:after {
  box-sizing: inherit;
}
html {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  padding: 0;
}
.loading {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #ffffffd6;
    z-index: 1000;
    font-weight: bolder;
    text-align: center;
    padding: 20px;
    top: 0;
}

.loading .md-progress {
    max-width: 500px;
    display: inline-block;
    margin-top: 25vh;
    height: 20px;
}

.loading span {
    display: block;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
}

.page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marvel-device .screen {
  text-align: left;
}

.screen-container {
  height: 100%;
}

/* Status Bar */

.status-bar {
  height: 25px;
  background: #004e45;
  color: #fff;
  font-size: 14px;
  padding: 0 8px;
}

.status-bar:after {
  content: "";
  display: table;
  clear: both;
}

.status-bar div {
  float: right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 0 0 8px;
  font-weight: 600;
}

/* Chat */

.chat {
  height: calc(100% - 69px);
}

.chat-container {
  height: 100%;
}

/* User Bar */

.user-bar {
  height: 55px;
  background: #005e54;
  color: #fff;
  padding: 0 8px;
  font-size: 24px;
  position: relative;
  z-index: 1;
}

.user-bar:after {
  content: "";
  display: table;
  clear: both;
}

.user-bar div {
  float: left;
  transform: translateY(-50%);
  position: relative;
  top: 50%;
}

.user-bar .actions {
  float: right;
  margin: 0 0 0 20px;
}

.user-bar .actions.more {
  margin: 0 12px 0 32px;
}

.user-bar .actions.attachment {
  margin: 0 0 0 30px;
}

.user-bar .actions.attachment i {
  display: block;
  transform: rotate(-45deg);
}

.user-bar .avatar {
  margin: 0 0 0 5px;
  width: 36px;
  height: 36px;
}

.user-bar .avatar img {
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1);
  display: block;
  width: 100%;
}

.user-bar .name {
  font-size: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
  margin: 0 0 0 8px;
  overflow: hidden;
  white-space: nowrap;
  width: 110px;
}

.user-bar .status {
  display: block;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
}

/* Conversation */

.conversation {
  height: calc(100% - 12px);
  position: relative;
  background: #efe7dd url("https://cloud.githubusercontent.com/assets/398893/15136779/4e765036-1639-11e6-9201-67e728e86f39.jpg") repeat;
  z-index: 0;
}

.conversation ::-webkit-scrollbar {
  transition: all .5s;
  width: 5px;
  height: 1px;
  z-index: 10;
}

.conversation ::-webkit-scrollbar-track {
  background: transparent;
}

.conversation ::-webkit-scrollbar-thumb {
  background: #b3ada7;
}

.conversation .conversation-container {
  height: calc(100% - 68px);
  box-shadow: inset 0 10px 10px -10px #000000;
  overflow-x: hidden;
  padding: 0 16px;
  margin-bottom: 5px;
}

.conversation .conversation-container:after {
  content: "";
  display: table;
  clear: both;
}

/* Messages */

.message {
  color: #262626;
  clear: both;
  line-height: 18px;
  font-size: 15px;
  padding: 8px;
  position: relative;
  margin: 8px 0;
  max-width: 85%;
  word-wrap: break-word;
  z-index: -1;
}

.message:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

.metadata {
  display: inline-block;
  float: right;
  padding: 0 0 0 7px;
  position: relative;
  bottom: -4px;
}

.metadata .time {
  color: rgba(0, 0, 0, .45);
  font-size: 11px;
  display: inline-block;
}

.metadata .tick {
  display: inline-block;
  margin-left: 2px;
  position: relative;
  top: 4px;
  height: 16px;
  width: 16px;
}

.metadata .tick svg {
  position: absolute;
  transition: .5s ease-in-out;
}

.metadata .tick svg:first-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(180deg);
          transform: perspective(800px) rotateY(180deg);
}

.metadata .tick svg:last-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(0deg);
          transform: perspective(800px) rotateY(0deg);
}

.metadata .tick-animation svg:first-child {
  -webkit-transform: perspective(800px) rotateY(0);
          transform: perspective(800px) rotateY(0);
}

.metadata .tick-animation svg:last-child {
  -webkit-transform: perspective(800px) rotateY(-179.9deg);
          transform: perspective(800px) rotateY(-179.9deg);
}

.message:first-child {
  margin: 16px 0 8px;
}

.message.received {
  background: #fff;
  border-radius: 0px 5px 5px 5px;
  float: left;
}

.message.received .metadata {
  padding: 0 0 0 16px;
}

.message.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  left: -10px;
}

.message.sent {
  background: #e1ffc7;
  border-radius: 5px 0px 5px 5px;
  float: right;
}

.message.sent:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #e1ffc7;
  top: 0;
  right: -10px;
}

/* Compose */

.conversation-compose {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  height: 50px;
  width: 100%;
  z-index: 2;
}

.conversation-compose div,
.conversation-compose input {
  background: #fff;
  height: 100%;
}

.conversation-compose .emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px 0 0 5px;
  flex: 0 0 auto;
  margin-left: 8px;
  width: 48px;
}

.conversation-compose .input-msg {
  border: 0;
  flex: 1 1 auto;
  font-size: 16px;
  margin: 0;
  outline: none;
  min-width: 50px;
}

.conversation-compose .photo {
  flex: 0 0 auto;
  border-radius: 0 0 5px 0;
  text-align: center;
  position: relative;
  width: 48px;
}

.conversation-compose .photo:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #fff;
  border-style: solid;
  position: absolute;
  width: 0;
  height: 0;
  content: "";
  top: 0;
  right: -10px;
}

.conversation-compose .photo i {
  display: block;
  color: #7d8488;
  font-size: 24px;
  transform: translate(-50%, -50%);
  position: relative;
  top: 50%;
  left: 50%;
}

.conversation-compose .send {
  background: transparent;
  border: 0;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  margin-right: 8px;
  padding: 0;
  position: relative;
  outline: none;
}

.conversation-compose .send .circle {
  background: #008a7c;
  border-radius: 50%;
  color: #fff;
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.conversation-compose .send .circle i {
  font-size: 24px;
  margin-left: 5px;
}

/* Small Screens */

@media (max-width: 768px) {
  .marvel-device.nexus5 {
    border-radius: 0;
    flex: none;
    padding: 0;
    max-width: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .marvel-device > .screen .chat {
    visibility: visible;
  }

  .marvel-device {
    visibility: hidden;
  }

  .marvel-device .status-bar {
    display: none;
  }

  .screen-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .conversation {
    height: calc(100vh - 55px);
  }
  .conversation .conversation-container {
    height: calc(100vh - 120px);
  }
}
.birth_filter .md-input-container {
    display: inline-grid;
}

.birth_filter .md-select.md-theme-default {
    display: inline;
}
.birth_filter label {
    position: relative !important;
}
.selected-tag + input.form-control {
    display: none !important;
}

.v-select {
    width: 200px !important;
    min-width: 200px !important;
}

.v-select button.clear,.v-select .open-indicator {
    line-height: 15px !important;
}
.md-input-container.select-border.filter-item {
    min-width: 210px !important;
}
</style>
<style scoped>
.md-select.md-theme-default {
  padding-left: 10px;
  height: 35px;
  border: 1px solid #e4e9f0;
  max-width: 100vw !important;
}

.page-charts {
  max-width: 100vw !important;
}
.main-content {
    padding: 15px !important;
}

.section-content.admin-content {
    max-width: 100vw !important;
}
.amol-picker{
  position: relative;
}
.amol-picker .required{
  color: #f26061;
}
@media (max-width: 600px){
    .chart-box {
        width: 100% !important;
        flex: 0 0 100% !important;
    }
}
.chart_button {
          margin-right: 10px !important;
    margin-left: 10px;
    border-radius: 4px;
    background-color: #bbedf1;
    margin: 20px 0;
    text-align: center
}
span.email_rec {
    float: left;
    margin-left: 5px;
}
 span.email_rec::after {
    content: ",";
}
 span.email_rec:last-child::after {
    content: " " !important;
}
total-stats .row {
  margin: 0 -15px;
  display: -moz-flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.total-stats .col-stats {
  padding: 15px;
  -moz-flex: 0 0 33.3%;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 33.3%;
          flex: 0 0 33.3%;
}
.total-stats .stat-item {
  border: 1px solid #d9d9d9;
  padding: 25px;
  width: 100%;
  border-radius: 4px;
}
.total-stats .stat-item h4 {
  font-size: 14px;
  text-transform: uppercase;
  color: #9da1a6;
  font-weight: 500;
  margin: 0;
}
.total-stats .stat-item .sign {
  opacity: 0.6;
  font-size: 20px;
  position: relative;
  top: -3px;
  padding-right: 4px;
  display: inline-block;
}
.total-stats .stat-item .type {
  padding-left: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.5;
  display: inline-block;
}
.total-stats .stat-item h3.stat-price {
  margin: 5px 0 0 0;
  letter-spacing: -0.03em;
  font-size: 25px;
  font-weight: 700;
  color: #76be33;
}
.total-stats .stat-item.stat-saved {
  border-color: #76be33;
  background-color: #8bd248;
}
.total-stats .stat-item.stat-saved h4 {
  color: #d9efc4;
}
.total-stats .stat-item.stat-saved h3 {
  color: #fff;
}
.total-stats .stat-item.stat-debt {
  border-color: #f26061;
}
.total-stats .stat-item.stat-debt h3.stat-price {
  color: #f26061;
}
.total-stats .stat-item.stat-debt.stat-saved {
  background-color: #f26061;
  border-color: #f0484a;
}
.total-stats .stat-item.stat-debt.stat-saved h4 {
  color: #fff;
  opacity: 0.9;
}
.total-stats .stat-item.stat-debt.stat-saved h3.stat-price {
  color: #fff;
}

.md-input-container {
    margin: 0;
    width: calc(100% - 40px);
    margin-left: 20px;
}
@media(min-width:555px){
.col-stats {
    width: 50% !important;
    float: left !important;
}
}
</style>



// WEBPACK FOOTER //
// PatientCoords.vue?52c45218